import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';

const resources = {
    en: {
        translation: {
            "Logout": "Logout",
            "Profile": "Profile",
            "My ride": "My ride",
            "Wallet": "Wallet",
            "Language": "Language",
            "Refer and earn": "Refer and earn",
            "Faq": "Faq",
            "Notification": "Notification",
            "Logout Successfully !!": "Logout Successfully !!",
            "Login": "Login",
            "Select Language": "Select Language",
            "Please enter phone number !!": "Please enter phone number !!",
            "In Valid OTP !!": "In Valid OTP !!",
            "Please enter passwords !!": "Please enter passwords !!",
            "Password not match !!": "Password not match !!",
            "Forgot Password": "Forgot Password",
            "Enter OTP code": "Enter OTP code",
            "Enter New Pasword": "Enter New Pasword",
            "Select which contact details should we use to reset your password": "Select which contact details should we use to reset your password",
            "OTP hase been sent to your mobile number": "OTP hase been sent to your mobile number",
            "Please enter your new password": "Please enter your new password",
            "Phone number": "Phone number",
            "Enter phone number": "Enter phone number",
            "Search": "Search",
            "Password": "Password",
            "Enter password": "Enter password",
            "Confirm Password": "Confirm Password",
            "Enter confirm password": "Enter confirm password",
            "Continue": "Continue",
            "Verify OTP": "Verify OTP",
            "Confirm": "Confirm",
            "Back": "Back",
            "Please enter password !!": "Please enter password !!",
            "Forgot Password?": "Forgot Password?",
            "By clicking continue. You agree to our": "By clicking continue. You agree to our",
            "Terms & Conditions": "Terms & Conditions",
            "Register Your Account": "Register Your Account",
            "Enter your information below.": "Enter your information below.",
            "Full Name": "Full Name",
            "Email Address": "Email Address",
            "Referral Code": "Referral Code",
            "Enter OTP Code": "Enter OTP Code",
            "Welcome To Your ZippyGo Ride!": "Welcome To Your ZippyGo Ride!",
            "Book a ride in just a few taps and reach your destination comfortably.": "Book a ride in just a few taps and reach your destination comfortably.",
            "Please fill all details !!": "Please fill all details !!",
            "Enter full name": "Enter full name",
            "Enter email address": "Enter email address",
            "Enter referral code(optional)": "Enter referral code(optional)",
            "Let's Go": "Let's Go",
            "Why do you want to cancel ?": "Why do you want to cancel ?",
            "Please provide the reason for cancellation.": "Please provide the reason for cancellation.",
            "Are you sure you want to cancel thi ride?": "Are you sure you want to cancel thi ride?",
            "We have found captains near you, please wait for a whilw, your ride should be.": "We have found captains near you, please wait for a whilw, your ride should be.",
            "Yes, Cancel": "Yes, Cancel",
            "Booking id": "Booking id",
            "Ride Details": "Ride Details",
            "Ride Type": "Ride Type",
            "Car Type": "Car Type",
            "Hours & Minites": "Hours & Minites",
            "Hours": "Hours",
            "Minites": "Minites",
            "Date & Time": "Date & Time",
            "Payment Details": "Payment Details",
            "Platform Fee": "Platform Fee",
            "Km Charge": "Km Charge",
            "Additional Time Charge": "Additional Time Charge",
            "Minutes": "Minutes",
            "Bid amount": "Bid amount",
            "Extra Charge": "Extra Charge",
            "Total": "Total",
            "Invoice": "Invoice",
            "Rate your ride": "Rate your ride",
            "Minimum fare is": "Minimum fare is",
            "Maximum fare is": "Maximum fare is",
            "Finding a ride": "Finding a ride",
            "for you": "for you",
            "ride": "ride",
            "💡 Raise the fare. increase your chance.": "💡 Raise the fare. increase your chance.",
            "Automatically book the nearest": "Automatically book the nearest",
            "driver for": "driver for",
            "Book for": "Book for",
            "Cancel request": "Cancel request",
            "Pickup": "Pickup",
            "Drop": "Drop",
            "Time's up. Extra charges apply": "Time's up. Extra charges apply",
            "Start your order with PIN": "Start your order with PIN",
            "Total Fare": "Total Fare",
            "Paying Via": "Paying Via",
            "Cancel Ride": "Cancel Ride",
            "Additional time": "Additional time",
            "minit": "minit",
            "Base Fare": "Base Fare",
            "Select Payment Method": "Select Payment Method",
            "Set your price": "Set your price",
            "Cash": "Cash",
            "Coupon": "Coupon",
            "Captain on the way": "Captain on the way",
            "Captain has arrived": "Captain has arrived",
            "Heading to the destination": "Heading to the destination,",
            "+ Add stop": "+ Add stop",
            "Choose your pickup spot": "Choose your pickup spot",
            "Confirm pickup": "Confirm pickup",
            "Cancel": "Cancel",
            "Location search": "Location search",
            "Set location on map": "Set location on map",
            "Recommended fare": "Recommended fare",
            "Total Km": "Total Km",
            "Total Hours": "Total Hours",
            "Total Minutes": "Total Minutes",
            "Weather Charge": "Weather Charge",
            "Extra Person Charge": "Extra Person Charge",
            "Day Charge": "Day Charge",
            "Per Hours Charge x 1": "Per Hours Charge x 1",
            "Per Hours Discount": "Per Hours Discount",
            "Kg Charge": "Kg Charge",
            "Tax": "Tax",
            "Total Price": "Total Price",
            "Find Driver": "Find Driver",
            "Select Coupon": "Select Coupon",
            "Coupon Code": "Coupon Code",
            "Coupon Amount": "Coupon Amount",
            "Minimum Amount": "Minimum Amount",
            "Ex Date": "Ex Date",
            "Apply Coupon": "Apply Coupon",
            "Remove Coupon": "Remove Coupon",
            "Captains are busy": "Captains are busy",
            "Try Again": "Try Again",
            "Package details": "Package details",
            "Save": "Save",
            "Log in to see ride options": "Log in to see ride options",
            "Please take a moment to quickly log in or sign up so we can show you your ride options": "Please take a moment to quickly log in or sign up so we can show you your ride options",
            "Please enter data in the previous field first !!": "Please enter data in the previous field first !!",
            "City to city": "City to city",
            "Rental": "Rental",
            "Freight": "Freight",
            "Pickup location": "Pickup location",
            "Dropoff location": "Dropoff location",
            "Stop location": "Stop location",
            "Search location": "Search location",
            "Length": "Length",
            "Width": "Width",
            "Height": "Height",
            "For example: a small box, about 1kg": "For example: a small box, about 1kg",
            "max_weight": "Maximum {{kg}} kg",
            "total_kg_placeholder": "Total Kg (Maximum {{kg}} kg)",
            "Select Ride Type": "Select Ride Type",
            "Select Outstation Services": "Select Outstation Services",
            "Available Vehicle Types": "Available Vehicle Types",
            "Select Date & Time": "Select Date & Time",
            "Number of passengers": "Number of passengers",
            "Rental Type": "Rental Type",
            "How much time do you need?": "How much time do you need?",
            "hours": "hours",
            "Sender & Recevier info": "Sender & Recevier info",
            "Vehicle size": "Vehicle size",
            "Please select pickup location !!": "Please select pickup location !!",
            "Please select dropoff location !!": "Please select dropoff location !!",
            "Please select all details !!": "Please select all details !!",
            "Please fill all stop locations !!": "Please fill all stop locations !!",
            "Select date": "Select date",
            "Select time": "Select time",
            "Find a driver": "Find a driver",
            "Choose a ride": "Choose a ride",
            "Please fill sender & recevier info !!": "Please fill sender & recevier info !!",
            "Please fill Package details !!": "Please fill Package details !!",
            "Create request": "Create request",
            "Sender Phone Number": "Sender Phone Number",
            "Recevier Phone Number": "Recevier Phone Number",
            "Enter details": "Enter details",
            "max_passenger": "Maximum passenger capacity {{count}}",
            "max_hours": "Maximum hours {{count}}",
            "Please write a message !!": "Please write a message !!",
            "Start Conversation...": "Start Conversation...",
            "Faq Question & Answer": "Faq Question & Answer",
            "Please select service !!": "Please select service !!",
            "Get a ride": "Get a ride",
            "Select service": "Select service",
            "min away - Drop": "min away - Drop",
            "Your ride,": "Your ride,",
            "your way": "your way",
            "Experience the next generation of urban mobility. Fast, reliable, and tailored": "Experience the next generation of urban mobility. Fast, reliable, and tailored",
            "to your daily needs.": "to your daily needs.",
            "Pickup Location": "Pickup Location",
            "Drop-off Location": "Drop-off Location",
            "Find Ride": "Find Ride",
            "Our Services": "Our Services",
            "Book now": "Book now",
            "Real-Time Tracking": "Real-Time Tracking",
            "Set Your Pickup": "Set Your Pickup",
            "Enter your pickup and drop location. Our system instantly finds the nearest driver to you.": "Enter your pickup and drop location. Our system instantly finds the nearest driver to you.",
            "Driver Matched": "Driver Matched",
            "A verified, top-rated driver is matched to your ride within 30 seconds of booking.": "A verified, top-rated driver is matched to your ride within 30 seconds of booking.",
            "Track in Real-Time": "Track in Real-Time",
            "Watch your driver's live location on the map. Share ETA with friends or family.": "Watch your driver's live location on the map. Share ETA with friends or family.",
            "Arrive & Pay": "Arrive & Pay",
            "Pay via UPI, card, or cash. Rate your driver and get a digital receipt instantly.": "Pay via UPI, card, or cash. Rate your driver and get a digital receipt instantly.",
            "Location permission not enabled": "Location permission not enabled",
            "Sharing Location permission helps us improve your ride booking and pickup experience.": "Sharing Location permission helps us improve your ride booking and pickup experience.",
            "Allow Permission": "Allow Permission",
            "Allow Notification and on-ride alerts": "Allow Notification and on-ride alerts",
            "Real-time Captain updates": "Real-time Captain updates",
            "Get notified about captain's allocation,": "Get notified about captain's allocation,",
            "arrival and more": "arrival and more",
            "Offer and news": "Offer and news",
            "Be the first to konw about our offers": "Be the first to konw about our offers",
            "and new features": "and new features",
            "Allow": "Allow",
            "Maybe, later": "Maybe, later",
            "Continue Booking": "Continue Booking",
            "Please select pickup and drop location !!": "Please select pickup and drop location !!",
            "Where from?": "Where from?",
            "Where to?": "Where to?",
            "Fast Pickup": "Fast Pickup",
            "Average wait time under 5 minutes in all major cities.": "Average wait time under 5 minutes in all major cities.",
            "Safe Rides": "Safe Rides", "Background checked drivers and SOS features for safety.": "Background checked drivers and SOS features for safety.",
            "24/7 Support": "24/7 Support",
            "Our dedicated team is always here to help you anywhere.": "Our dedicated team is always here to help you anywhere.",
            "Best Prices": "Best Prices",
            "Optimized routes and fair pricing compared to others.": "Optimized routes and fair pricing compared to others.",
            "Payment was faild! please try agine": "Payment was faild! please try agine",
            "Rides History": "Rides History",
            "View your completed rides and upcoming bookings.": "View your completed rides and upcoming bookings.",
            "Upcoming": "Upcoming",
            "Completed": "Completed",
            "Cancelled": "Cancelled",
            "Date": "Date",
            "Time": "Time",
            "Estimated Fare": "Estimated Fare",
            "PICKUP": "PICKUP",
            "DESTINATION": "DESTINATION",
            "View Details": "View Details",
            "No Order Found!": "No Order Found!",
            "Currently you don't have order.": "Currently you don't have order.",
            "Review & Rating": "Review & Rating",
            "How was your ride with": "How was your ride with",
            "Great, what did you like the mast? 😍": "Great, what did you like the mast? 😍",
            "Submit": "Submit",
            "Skip": "Skip",
            "Driver Profile": "Driver Profile",
            "Rating": "Rating",
            "Trips": "Trips",
            "Joined": "Joined",
            "Since": "Since",
            "Verified": "Verified",
            "Reviews": "Reviews",
            "Languages": "Languages",
            "Preference": "Preference",
            "Phone Number": "Phone Number",
            "Referral code copied!": "Referral code copied!",
            "Refer & Earn": "Refer & Earn",
            "Share and earn rewards together!": "Share and earn rewards together!",
            "Your Referral Code": "Your Referral Code",
            "Share this code with your friends": "Share this code with your friends",
            "Copy": "Copy",
            "WhatsApp": "WhatsApp",
            "SMS": "SMS",
            "More": "More",
            "Share via your favorite social platform": "Share via your favorite social platform",
            "How It Works": "How It Works",
            "Share Your Code": "Share Your Code",
            "Share your unique referral code with friends and family": "Share your unique referral code with friends and family",
            "Friend Signs Up": "Friend Signs Up",
            "You Earn Rewards": "You Earn Rewards",
            "Everyone Wins!": "Everyone Wins!",
            "Both you and your friend can use the credits for consultations, medicines, and lab tests": "Both you and your friend can use the credits for consultations, medicines, and lab tests",
            "My Wallet": "My Wallet",
            "Total Balance": "Total Balance",
            "Add Money": "Add Money",
            "Transaction History": "Transaction History",
            "No transactions yet": "No transactions yet",
            "Your transaction history will appear here": "Your transaction history will appear here",
            "Build better products with flexible tools, helpful documentation": "Build better products with flexible tools, helpful documentation",
            "and a team that champions your growth.": "and a team that champions your growth.",
            "Useful Link": "Useful Link",
            "Socials": "Socials",
            "* Terms and conditions apply. Rewards will be credited after successful signup.": "* Terms and conditions apply. Rewards will be credited after successful signup.",
            "Enter Full Name": "Enter Full Name",
            "Enter Email Address": "Enter Email Address",
            "Enter Password": "Enter Password",
            "Enter Phone Number": "Enter Phone Number",
            "Credit": "Credit",
            "Debit": "Debit",
            "Update": "Update",
            "Please enter amount !!": "Please enter amount !!",
            "Please select payment method": "Please select payment method",
            "Select Paymet Method": "Select Paymet Method",
            "Add Wallet Amount": "Add Wallet Amount",
            "Enter amount": "Enter amount",
            "refer_credit": "You receive ₹{{refer_credit}} in your wallet for each successful referral",
            "signup_credit": "Your friend registers using your referral code and gets ₹{{signup_credit}} instantly",
            "footer_title": "© {{getFullYear}} ZippyGo. All rights reserved.",
            "Driver Offer": "Driver Offer",
            "km": "km",
            "min": "min",
            "Decline": "Decline",
            "Accept": "Accept",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
        }
    },
    sp: {
        translation: {
            "Logout": "Cerrar sesión",
            "Profile": "Perfil",
            "My ride": "Mis viajes",
            "Wallet": "Billetera",
            "Language": "Idioma",
            "Refer and earn": "Referir y ganar",
            "Faq": "Preguntas frecuentes",
            "Notification": "Notificación",
            "Logout Successfully !!": "¡Cierre de sesión exitoso!",
            "Login": "Iniciar sesión",
            "Select Language": "Seleccionar idioma",
            "Please enter phone number !!": "¡Por favor ingrese el número de teléfono!",
            "In Valid OTP !!": "¡OTP inválido!",
            "Please enter passwords !!": "¡Por favor ingrese la contraseña!",
            "Password not match !!": "¡Las contraseñas no coinciden!",
            "Forgot Password": "Olvidé mi contraseña",
            "Enter OTP code": "Ingrese el código OTP",
            "Enter New Pasword": "Ingrese nueva contraseña",
            "Select which contact details should we use to reset your password": "Seleccione qué datos de contacto debemos usar para restablecer su contraseña",
            "OTP hase been sent to your mobile number": "El OTP ha sido enviado a su número móvil",
            "Please enter your new password": "Por favor ingrese su nueva contraseña",
            "Phone number": "Número de teléfono",
            "Enter phone number": "Ingrese número de teléfono",
            "Search": "Buscar",
            "Password": "Contraseña",
            "Enter password": "Ingrese contraseña",
            "Confirm Password": "Confirmar contraseña",
            "Enter confirm password": "Ingrese confirmación de contraseña",
            "Continue": "Continuar",
            "Verify OTP": "Verificar OTP",
            "Confirm": "Confirmar",
            "Back": "Atrás",
            "Please enter password !!": "¡Por favor ingrese la contraseña!",
            "Forgot Password?": "¿Olvidó su contraseña?",
            "By clicking continue. You agree to our": "Al hacer clic en continuar, usted acepta nuestros",
            "Terms & Conditions": "Términos y condiciones",
            "Register Your Account": "Registre su cuenta",
            "Enter your information below.": "Ingrese su información a continuación.",
            "Full Name": "Nombre completo",
            "Email Address": "Correo electrónico",
            "Referral Code": "Código de referido",
            "Enter OTP Code": "Ingrese el código OTP",
            "Welcome To Your ZippyGo Ride!": "¡Bienvenido a su viaje con ZippyGo!",
            "Book a ride in just a few taps and reach your destination comfortably.": "Reserve un viaje en pocos toques y llegue a su destino cómodamente.",
            "Please fill all details !!": "¡Por favor complete todos los detalles!",
            "Enter full name": "Ingrese nombre completo",
            "Enter email address": "Ingrese correo electrónico",
            "Enter referral code(optional)": "Ingrese código de referido (opcional)",
            "Let's Go": "¡Vamos!",
            "Why do you want to cancel ?": "¿Por qué desea cancelar?",
            "Please provide the reason for cancellation.": "Por favor proporcione el motivo de la cancelación.",
            "Are you sure you want to cancel thi ride?": "¿Está seguro de que desea cancelar este viaje?",
            "We have found captains near you, please wait for a while, your ride should be.": "Hemos encontrado conductores cerca de usted, por favor espere un momento.",
            "Yes, Cancel": "Sí, cancelar",
            "Booking id": "ID de reserva",
            "Ride Details": "Detalles del viaje",
            "Ride Type": "Tipo de viaje",
            "Car Type": "Tipo de vehículo",
            "Hours & Minites": "Horas y minutos",
            "Hours": "Horas",
            "Minites": "Minutos",
            "Date & Time": "Fecha y hora",
            "Payment Details": "Detalles de pago",
            "Platform Fee": "Tarifa de plataforma",
            "Km Charge": "Costo por km",
            "Additional Time Charge": "Cargo por tiempo adicional",
            "Minutes": "Minutos",
            "Bid amount": "Monto de la oferta",
            "Extra Charge": "Cargo extra",
            "Total": "Total",
            "Invoice": "Factura",
            "Rate your ride": "Califique su viaje",
            "Minimum fare is": "La tarifa mínima es",
            "Maximum fare is": "La tarifa máxima es",
            "Finding a ride": "Buscando un viaje",
            "for you": "para usted",
            "ride": "viaje",
            "💡 Raise the fare. increase your chance.": "💡 Aumente la tarifa. Incrementa sus posibilidades.",
            "Automatically book the nearest": "Reservar automáticamente el más cercano",
            "driver for": "conductor para",
            "Book for": "Reservar por",
            "Cancel request": "Cancelar solicitud",
            "Pickup": "Recogida",
            "Drop": "Destino",
            "Time's up. Extra charges apply": "Se acabó el tiempo. Se aplican cargos adicionales",
            "Start your order with PIN": "Inicie su viaje con PIN",
            "Total Fare": "Tarifa total",
            "Paying Via": "Pagando vía",
            "Cancel Ride": "Cancelar viaje",
            "Additional time": "Tiempo adicional",
            "minit": "min",
            "Base Fare": "Tarifa base",
            "Select Payment Method": "Seleccionar método de pago",
            "Set your price": "Establezca su precio",
            "Cash": "Efectivo",
            "Coupon": "Cupón",
            "Captain on the way": "Conductor en camino",
            "Captain has arrived": "El conductor ha llegado",
            "Heading to the destination": "En camino al destino",
            "+ Add stop": "+ Agregar parada",
            "Choose your pickup spot": "Elija su punto de recogida",
            "Confirm pickup": "Confirmar recogida",
            "Cancel": "Cancelar",
            "Location search": "Búsqueda de ubicación",
            "Set location on map": "Establecer ubicación en el mapa",
            "Recommended fare": "Tarifa recomendada",
            "Total Km": "Km totales",
            "Total Hours": "Horas totales",
            "Total Minutes": "Minutos totales",
            "Weather Charge": "Cargo por clima",
            "Extra Person Charge": "Cargo por persona extra",
            "Day Charge": "Cargo por día",
            "Per Hours Charge x 1": "Cargo por hora x 1",
            "Per Hours Discount": "Descuento por hora",
            "Kg Charge": "Cargo por kg",
            "Tax": "Impuesto",
            "Total Price": "Precio total",
            "Find Driver": "Buscar conductor",
            "Select Coupon": "Seleccionar cupón",
            "Coupon Code": "Código de cupón",
            "Coupon Amount": "Monto del cupón",
            "Minimum Amount": "Monto mínimo",
            "Ex Date": "Fecha de expiración",
            "Apply Coupon": "Aplicar cupón",
            "Remove Coupon": "Eliminar cupón",
            "Captains are busy": "Los conductores están ocupados",
            "Try Again": "Intentar de nuevo",
            "Package details": "Detalles del paquete",
            "Save": "Guardar",
            "Log in to see ride options": "Inicie sesión para ver opciones de viaje",
            "Please take a moment to quickly log in or sign up so we can show you your ride options": "Por favor, inicie sesión o regístrese rápidamente para ver sus opciones de viaje",
            "Please enter data in the previous field first !!": "¡Por favor ingrese datos en el campo anterior primero!",
            "City to city": "De ciudad a ciudad",
            "Rental": "Alquiler",
            "Freight": "Carga",
            "Pickup location": "Ubicación de recogida",
            "Dropoff location": "Ubicación de destino",
            "Stop location": "Ubicación de parada",
            "Search location": "Buscar ubicación",
            "Length": "Longitud",
            "Width": "Ancho",
            "Height": "Altura",
            "For example: a small box, about 1kg": "Por ejemplo: una caja pequeña, de aproximadamente 1 kg",
            "max_weight": "Peso máximo {{kg}} kg",
            "total_kg_placeholder": "Kg total (Máximo {{kg}} kg)",
            "Select Ride Type": "Seleccionar tipo de viaje",
            "Select Outstation Services": "Seleccionar servicios interurbanos",
            "Available Vehicle Types": "Tipos de vehículos disponibles",
            "Select Date & Time": "Seleccionar fecha y hora",
            "Number of passengers": "Número de pasajeros",
            "Rental Type": "Tipo de alquiler",
            "How much time do you need?": "¿Cuánto tiempo necesita?",
            "hours": "horas",
            "Sender & Recevier info": "Información del remitente y receptor",
            "Vehicle size": "Tamaño del vehículo",
            "Please select pickup location !!": "¡Por favor seleccione la ubicación de recogida!",
            "Please select dropoff location !!": "¡Por favor seleccione la ubicación de destino!",
            "Please select all details !!": "¡Por favor seleccione todos los detalles!",
            "Please fill all stop locations !!": "¡Por favor complete todas las ubicaciones de parada!",
            "Select date": "Seleccionar fecha",
            "Select time": "Seleccionar hora",
            "Find a driver": "Buscar un conductor",
            "Choose a ride": "Elegir un viaje",
            "Please fill sender & recevier info !!": "¡Por favor complete la información del remitente y receptor!",
            "Please fill Package details !!": "¡Por favor complete los detalles del paquete!",
            "Create request": "Crear solicitud",
            "Sender Phone Number": "Número de teléfono del remitente",
            "Recevier Phone Number": "Número de teléfono del receptor",
            "Enter details": "Ingrese detalles",
            "max_passenger": "Capacidad máxima de pasajeros {{count}}",
            "max_hours": "Horas máximas {{count}}",
            "Please write a message !!": "¡Por favor escriba un mensaje!",
            "Start Conversation...": "Iniciar conversación...",
            "Faq Question & Answer": "Preguntas y respuestas frecuentes",
            "Please select service !!": "¡Por favor seleccione un servicio!",
            "Get a ride": "Solicitar un viaje",
            "Select service": "Seleccionar servicio",
            "min away - Drop": "min de distancia - destino",
            "Your ride,": "Tu viaje,",
            "your way": "a tu manera",
            "Experience the next generation of urban mobility. Fast, reliable, and tailored": "Experimenta la nueva generación de movilidad urbana. Rápida, confiable y adaptada",
            "to your daily needs.": "a tus necesidades diarias.",
            "Pickup Location": "Ubicación de recogida",
            "Drop-off Location": "Ubicación de destino",
            "Find Ride": "Buscar viaje",
            "Our Services": "Nuestros servicios",
            "Book now": "Reservar ahora",
            "Real-Time Tracking": "Seguimiento en tiempo real",
            "Set Your Pickup": "Establece tu recogida",
            "Enter your pickup and drop location. Our system instantly finds the nearest driver to you.": "Ingrese su ubicación de recogida y destino. Nuestro sistema encuentra instantáneamente el conductor más cercano.",
            "Driver Matched": "Conductor asignado",
            "A verified, top-rated driver is matched to your ride within 30 seconds of booking.": "Un conductor verificado y bien calificado se asigna a su viaje en menos de 30 segundos.",
            "Track in Real-Time": "Rastrea en tiempo real",
            "Watch your driver's live location on the map. Share ETA with friends or family.": "Vea la ubicación en vivo de su conductor en el mapa. Comparta el tiempo estimado con amigos o familiares.",
            "Arrive & Pay": "Llegar y pagar",
            "Pay via UPI, card, or cash. Rate your driver and get a digital receipt instantly.": "Pague con UPI, tarjeta o efectivo. Califique a su conductor y obtenga un recibo digital al instante.",
            "Location permission not enabled": "Permiso de ubicación no habilitado",
            "Sharing Location permission helps us improve your ride booking and pickup experience.": "Compartir el permiso de ubicación nos ayuda a mejorar su experiencia de reserva y recogida.",
            "Allow Permission": "Permitir permiso",
            "Allow Notification and on-ride alerts": "Permitir notificaciones y alertas de viaje",
            "Real-time Captain updates": "Actualizaciones del conductor en tiempo real",
            "Get notified about captain's allocation,": "Reciba notificaciones sobre la asignación del conductor,",
            "arrival and more": "llegada y más",
            "Offer and news": "Ofertas y noticias",
            "Be the first to konw about our offers": "Sea el primero en conocer nuestras ofertas",
            "and new features": "y nuevas funciones",
            "Allow": "Permitir",
            "Maybe, later": "Quizás más tarde",
            "Continue Booking": "Continuar reserva",
            "Please select pickup and drop location !!": "¡Por favor seleccione la ubicación de recogida y destino!",
            "Where from?": "¿Desde dónde?",
            "Where to?": "¿Hacia dónde?",
            "Fast Pickup": "Recogida rápida",
            "Average wait time under 5 minutes in all major cities.": "Tiempo promedio de espera menor a 5 minutos en las principales ciudades.",
            "Safe Rides": "Viajes seguros",
            "Background checked drivers and SOS features for safety.": "Conductores verificados y funciones SOS para mayor seguridad.",
            "24/7 Support": "Soporte 24/7",
            "Our dedicated team is always here to help you anywhere.": "Nuestro equipo dedicado siempre está aquí para ayudarte en cualquier lugar.",
            "Best Prices": "Mejores precios",
            "Optimized routes and fair pricing compared to others.": "Rutas optimizadas y precios justos en comparación con otros.",
            "Payment was faild! please try agine": "¡El pago falló! Por favor, inténtalo de nuevo",
            "Rides History": "Historial de viajes",
            "View your completed rides and upcoming bookings.": "Consulta tus viajes completados y reservas próximas.",
            "Upcoming": "Próximos",
            "Completed": "Completados",
            "Cancelled": "Cancelados",
            "Date": "Fecha",
            "Time": "Hora",
            "Estimated Fare": "Tarifa estimada",
            "PICKUP": "RECOGIDA",
            "DESTINATION": "DESTINO",
            "View Details": "Ver detalles",
            "No Order Found!": "¡No se encontraron pedidos!",
            "Currently you don't have order.": "Actualmente no tienes pedidos.",
            "Review & Rating": "Reseña y calificación",
            "How was your ride with": "¿Cómo fue tu viaje con",
            "Great, what did you like the mast? 😍": "Genial, ¿qué fue lo que más te gustó? 😍",
            "Submit": "Enviar",
            "Skip": "Omitir",
            "Driver Profile": "Perfil del conductor",
            "Rating": "Calificación",
            "Trips": "Viajes",
            "Joined": "Se unió",
            "Since": "Desde",
            "Verified": "Verificado",
            "Reviews": "Reseñas",
            "Languages": "Idiomas",
            "Preference": "Preferencias",
            "Phone Number": "Número de teléfono",
            "Referral code copied!": "¡Código de referido copiado!",
            "Refer & Earn": "Referir y ganar",
            "Share and earn rewards together!": "¡Comparte y gana recompensas juntos!",
            "Your Referral Code": "Tu código de referido",
            "Share this code with your friends": "Comparte este código con tus amigos",
            "Copy": "Copiar",
            "WhatsApp": "WhatsApp",
            "SMS": "SMS",
            "More": "Más",
            "Share via your favorite social platform": "Comparte a través de tu plataforma social favorita",
            "How It Works": "Cómo funciona",
            "Share Your Code": "Comparte tu código",
            "Share your unique referral code with friends and family": "Comparte tu código de referido único con amigos y familiares",
            "Friend Signs Up": "El amigo se registra",
            "You Earn Rewards": "Ganas recompensas",
            "Everyone Wins!": "¡Todos ganan!",
            "Both you and your friend can use the credits for consultations, medicines, and lab tests": "Tanto tú como tu amigo pueden usar los créditos para consultas, medicamentos y pruebas de laboratorio",
            "My Wallet": "Mi billetera",
            "Total Balance": "Saldo total",
            "Add Money": "Agregar dinero",
            "Transaction History": "Historial de transacciones",
            "No transactions yet": "Aún no hay transacciones",
            "Your transaction history will appear here": "Tu historial de transacciones aparecerá aquí",
            "Build better products with flexible tools, helpful documentation": "Crea mejores productos con herramientas flexibles y documentación útil",
            "and a team that champions your growth.": "y un equipo que impulsa tu crecimiento.",
            "Useful Link": "Enlaces útiles",
            "Socials": "Redes sociales",
            "* Terms and conditions apply. Rewards will be credited after successful signup.": "* Se aplican términos y condiciones. Las recompensas se acreditarán después de un registro exitoso.",
            "Enter Full Name": "Ingrese nombre completo",
            "Enter Email Address": "Ingrese correo electrónico",
            "Enter Password": "Ingrese contraseña",
            "Enter Phone Number": "Ingrese número de teléfono",
            "Credit": "Crédito",
            "Debit": "Débito",
            "Update": "Actualizar",
            "Please enter amount !!": "¡Por favor ingrese el monto!",
            "Please select payment method": "Por favor seleccione un método de pago",
            "Select Paymet Method": "Seleccionar método de pago",
            "Add Wallet Amount": "Agregar saldo a la billetera",
            "Enter amount": "Ingrese monto",
            "refer_credit": "Recibes ₹{{refer_credit}} en tu billetera por cada referido exitoso",
            "signup_credit": "Tu amigo se registra usando tu código de referido y recibe ₹{{signup_credit}} al instante",
            "footer_title": "© {{getFullYear}} ZippyGo. Todos los derechos reservados.",
            "Driver Offer": "Oferta del conductor",
            "km": "km",
            "min": "min",
            "Decline": "Rechazar",
            "Accept": "Aceptar",
            "Install Progressive Web Application": "Instalar aplicación web progresiva",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "Este sitio tiene funcionalidad de aplicación. Instálalo en tu dispositivo para una mejor experiencia y acceso fácil.",
            "Install": "Instalar"
        }
    },
    hi: {
        translation: {
            "Logout": "लॉगआउट",
            "Profile": "प्रोफ़ाइल",
            "My ride": "मेरी राइड",
            "Wallet": "वॉलेट",
            "Language": "भाषा",
            "Refer and earn": "रेफर करें और कमाएँ",
            "Faq": "सामान्य प्रश्न",
            "Notification": "सूचनाएं",
            "Logout Successfully !!": "सफलतापूर्वक लॉगआउट हो गया !!",
            "Login": "लॉगिन",
            "Select Language": "भाषा चुनें",
            "Please enter phone number !!": "कृपया फोन नंबर दर्ज करें !!",
            "In Valid OTP !!": "अमान्य ओटीपी !!",
            "Please enter passwords !!": "कृपया पासवर्ड दर्ज करें !!",
            "Password not match !!": "पासवर्ड मेल नहीं खा रहा !!",
            "Forgot Password": "पासवर्ड भूल गए",
            "Enter OTP code": "ओटीपी कोड दर्ज करें",
            "Enter New Pasword": "नया पासवर्ड दर्ज करें",
            "Select which contact details should we use to reset your password": "पासवर्ड रीसेट करने के लिए किस संपर्क विवरण का उपयोग करें, चुनें",
            "OTP hase been sent to your mobile number": "ओटीपी आपके मोबाइल नंबर पर भेज दिया गया है",
            "Please enter your new password": "कृपया अपना नया पासवर्ड दर्ज करें",
            "Phone number": "फोन नंबर",
            "Enter phone number": "फोन नंबर दर्ज करें",
            "Search": "खोजें",
            "Password": "पासवर्ड",
            "Enter password": "पासवर्ड दर्ज करें",
            "Confirm Password": "पासवर्ड की पुष्टि करें",
            "Enter confirm password": "पुष्टि पासवर्ड दर्ज करें",
            "Continue": "जारी रखें",
            "Verify OTP": "ओटीपी सत्यापित करें",
            "Confirm": "पुष्टि करें",
            "Back": "वापस",
            "Please enter password !!": "कृपया पासवर्ड दर्ज करें !!",
            "Forgot Password?": "पासवर्ड भूल गए?",
            "By clicking continue. You agree to our": "जारी रखें पर क्लिक करके, आप हमारी शर्तों से सहमत हैं",
            "Terms & Conditions": "नियम और शर्तें",
            "Register Your Account": "अपना खाता पंजीकृत करें",
            "Enter your information below.": "नीचे अपनी जानकारी दर्ज करें",
            "Full Name": "पूरा नाम",
            "Email Address": "ईमेल पता",
            "Referral Code": "रेफरल कोड",
            "Enter OTP Code": "ओटीपी कोड दर्ज करें",
            "Welcome To Your ZippyGo Ride!": "आपकी ZippyGo राइड में आपका स्वागत है!",
            "Book a ride in just a few taps and reach your destination comfortably.": "कुछ ही टैप में राइड बुक करें और आराम से अपनी मंज़िल तक पहुँचें",
            "Please fill all details !!": "कृपया सभी विवरण भरें !!",
            "Enter full name": "पूरा नाम दर्ज करें",
            "Enter email address": "ईमेल पता दर्ज करें",
            "Enter referral code(optional)": "रेफरल कोड दर्ज करें (वैकल्पिक)",
            "Let's Go": "चलें",
            "Why do you want to cancel ?": "आप राइड क्यों रद्द करना चाहते हैं?",
            "Please provide the reason for cancellation.": "कृपया रद्द करने का कारण बताएं",
            "Are you sure you want to cancel thi ride?": "क्या आप वाकई इस राइड को रद्द करना चाहते हैं?",
            "We have found captains near you, please wait for a whilw, your ride should be.": "हमें आपके पास ड्राइवर मिल गए हैं, कृपया थोड़ी देर प्रतीक्षा करें, आपकी राइड जल्द ही कन्फर्म हो जाएगी",
            "Yes, Cancel": "हाँ, रद्द करें",
            "Booking id": "बुकिंग आईडी",
            "Ride Details": "राइड विवरण",
            "Ride Type": "राइड प्रकार",
            "Car Type": "कार प्रकार",
            "Hours & Minites": "घंटे और मिनट",
            "Hours": "घंटे",
            "Minites": "मिनट",
            "Date & Time": "तारीख और समय",
            "Payment Details": "भुगतान विवरण",
            "Platform Fee": "प्लेटफ़ॉर्म शुल्क",
            "Km Charge": "प्रति किमी शुल्क",
            "Additional Time Charge": "अतिरिक्त समय शुल्क",
            "Minutes": "मिनट",
            "Bid amount": "बोली राशि",
            "Extra Charge": "अतिरिक्त शुल्क",
            "Total": "कुल",
            "Invoice": "इनवॉइस",
            "Rate your ride": "अपनी राइड को रेट करें",
            "Minimum fare is": "न्यूनतम किराया है",
            "Maximum fare is": "अधिकतम किराया है",
            "Finding a ride": "राइड खोजी जा रही है",
            "for you": "आपके लिए",
            "ride": "राइड",
            "💡 Raise the fare. increase your chance.": "💡 किराया बढ़ाएं, आपकी राइड मिलने की संभावना बढ़ेगी",
            "Automatically book the nearest": "निकटतम ड्राइवर को स्वचालित रूप से बुक करें",
            "driver for": "ड्राइवर के लिए",
            "Book for": "के लिए बुक करें",
            "Cancel request": "अनुरोध रद्द करें",
            "Pickup": "पिकअप",
            "Drop": "ड्रॉप",
            "Time's up. Extra charges apply": "समय समाप्त हो गया। अतिरिक्त शुल्क लागू होगा",
            "Start your order with PIN": "पिन के साथ अपनी राइड शुरू करें",
            "Total Fare": "कुल किराया",
            "Paying Via": "भुगतान का तरीका",
            "Cancel Ride": "राइड रद्द करें",
            "Additional time": "अतिरिक्त समय",
            "minit": "मिनट",
            "Base Fare": "मूल किराया",
            "Select Payment Method": "भुगतान विधि चुनें",
            "Set your price": "अपनी कीमत तय करें",
            "Cash": "नकद",
            "Coupon": "कूपन",
            "Captain on the way": "ड्राइवर रास्ते में है",
            "Captain has arrived": "ड्राइवर पहुँच गया है",
            "Heading to the destination": "गंतव्य की ओर जा रहे हैं",
            "+ Add stop": "+ स्टॉप जोड़ें",
            "Choose your pickup spot": "अपना पिकअप स्थान चुनें",
            "Confirm pickup": "पिकअप की पुष्टि करें",
            "Cancel": "रद्द करें",
            "Location search": "लोकेशन खोजें",
            "Set location on map": "मैप पर लोकेशन सेट करें",
            "Recommended fare": "अनुशंसित किराया",
            "Total Km": "कुल किमी",
            "Total Hours": "कुल घंटे",
            "Total Minutes": "कुल मिनट",
            "Weather Charge": "मौसम शुल्क",
            "Extra Person Charge": "अतिरिक्त व्यक्ति शुल्क",
            "Day Charge": "दैनिक शुल्क",
            "Per Hours Charge x 1": "प्रति घंटे शुल्क x 1",
            "Per Hours Discount": "प्रति घंटे छूट",
            "Kg Charge": "वजन शुल्क",
            "Tax": "कर",
            "Total Price": "कुल कीमत",
            "Find Driver": "ड्राइवर खोजें",
            "Select Coupon": "कूपन चुनें",
            "Coupon Code": "कूपन कोड",
            "Coupon Amount": "कूपन राशि",
            "Minimum Amount": "न्यूनतम राशि",
            "Ex Date": "समाप्ति तिथि",
            "Apply Coupon": "कूपन लागू करें",
            "Remove Coupon": "कूपन हटाएं",
            "Captains are busy": "ड्राइवर व्यस्त हैं",
            "Try Again": "फिर से प्रयास करें",
            "Package details": "पैकेज विवरण",
            "Save": "सहेजें",
            "Log in to see ride options": "राइड विकल्प देखने के लिए लॉगिन करें",
            "Please take a moment to quickly log in or sign up so we can show you your ride options": "कृपया राइड विकल्प देखने के लिए लॉगिन या साइन अप करें",
            "Please enter data in the previous field first !!": "कृपया पहले पिछले फ़ील्ड में डेटा दर्ज करें !!",
            "City to city": "शहर से शहर",
            "Rental": "किराये पर",
            "Freight": "माल ढुलाई",
            "Pickup location": "पिकअप स्थान",
            "Dropoff location": "ड्रॉप स्थान",
            "Stop location": "स्टॉप स्थान",
            "Search location": "लोकेशन खोजें",
            "Length": "लंबाई",
            "Width": "चौड़ाई",
            "Height": "ऊंचाई",
            "For example: a small box, about 1kg": "उदाहरण: एक छोटा बॉक्स, लगभग 1 किलोग्राम",
            "max_weight": "अधिकतम {{kg}} किलोग्राम",
            "total_kg_placeholder": "कुल किलोग्राम (अधिकतम {{kg}} किलोग्राम)",
            "Select Ride Type": "राइड प्रकार चुनें",
            "Select Outstation Services": "आउटस्टेशन सेवाएं चुनें",
            "Available Vehicle Types": "उपलब्ध वाहन प्रकार",
            "Select Date & Time": "तारीख और समय चुनें",
            "Number of passengers": "यात्रियों की संख्या",
            "Rental Type": "किराया प्रकार",
            "How much time do you need?": "आपको कितने समय की आवश्यकता है?",
            "hours": "घंटे",
            "Sender & Recevier info": "प्रेषक और प्राप्तकर्ता की जानकारी",
            "Vehicle size": "वाहन का आकार",
            "Please select pickup location !!": "कृपया पिकअप स्थान चुनें !!",
            "Please select dropoff location !!": "कृपया ड्रॉप स्थान चुनें !!",
            "Please select all details !!": "कृपया सभी विवरण चुनें !!",
            "Please fill all stop locations !!": "कृपया सभी स्टॉप लोकेशन भरें !!",
            "Select date": "तारीख चुनें",
            "Select time": "समय चुनें",
            "Find a driver": "ड्राइवर खोजें",
            "Choose a ride": "राइड चुनें",
            "Please fill sender & recevier info !!": "कृपया प्रेषक और प्राप्तकर्ता की जानकारी भरें !!",
            "Please fill Package details !!": "कृपया पैकेज विवरण भरें !!",
            "Create request": "अनुरोध बनाएं",
            "Sender Phone Number": "प्रेषक का फोन नंबर",
            "Recevier Phone Number": "प्राप्तकर्ता का फोन नंबर",
            "Enter details": "विवरण दर्ज करें",
            "max_passenger": "अधिकतम {{count}} यात्री",
            "max_hours": "अधिकतम {{count}} घंटे",
            "Please write a message !!": "कृपया एक संदेश लिखें !!",
            "Start Conversation...": "बातचीत शुरू करें...",
            "Faq Question & Answer": "सामान्य प्रश्न और उत्तर",
            "Please select service !!": "कृपया सेवा चुनें !!",
            "Get a ride": "राइड बुक करें",
            "Select service": "सेवा चुनें",
            "min away - Drop": "मिनट दूर - ड्रॉप",
            "Your ride,": "आपकी राइड,",
            "your way": "आपके तरीके से",
            "Experience the next generation of urban mobility. Fast, reliable, and tailored": "शहरी यात्रा के अगले स्तर का अनुभव करें। तेज, भरोसेमंद और आपकी जरूरतों के अनुसार",
            "to your daily needs.": "आपकी रोज़मर्रा की जरूरतों के लिए",
            "Pickup Location": "पिकअप स्थान",
            "Drop-off Location": "ड्रॉप स्थान",
            "Find Ride": "राइड खोजें",
            "Our Services": "हमारी सेवाएं",
            "Book now": "अभी बुक करें",
            "Real-Time Tracking": "रियल-टाइम ट्रैकिंग",
            "Set Your Pickup": "अपना पिकअप सेट करें",
            "Enter your pickup and drop location. Our system instantly finds the nearest driver to you.": "अपना पिकअप और ड्रॉप स्थान दर्ज करें। हमारा सिस्टम तुरंत आपके लिए नज़दीकी ड्राइवर ढूंढता है",
            "Driver Matched": "ड्राइवर मिल गया",
            "A verified, top-rated driver is matched to your ride within 30 seconds of booking.": "बुकिंग के 30 सेकंड के भीतर एक सत्यापित और उच्च रेटिंग वाला ड्राइवर आपकी राइड से जुड़ जाता है",
            "Track in Real-Time": "रियल-टाइम में ट्रैक करें",
            "Watch your driver's live location on the map. Share ETA with friends or family.": "मैप पर ड्राइवर की लाइव लोकेशन देखें। ETA को दोस्तों या परिवार के साथ साझा करें",
            "Arrive & Pay": "पहुंचें और भुगतान करें",
            "Pay via UPI, card, or cash. Rate your driver and get a digital receipt instantly.": "UPI, कार्ड या नकद से भुगतान करें। ड्राइवर को रेट करें और तुरंत डिजिटल रसीद प्राप्त करें",
            "Location permission not enabled": "लोकेशन अनुमति सक्षम नहीं है",
            "Sharing Location permission helps us improve your ride booking and pickup experience.": "लोकेशन अनुमति साझा करने से आपकी राइड बुकिंग और पिकअप अनुभव बेहतर होता है",
            "Allow Permission": "अनुमति दें",
            "Allow Notification and on-ride alerts": "नोटिफिकेशन और राइड अलर्ट की अनुमति दें",
            "Real-time Captain updates": "रियल-टाइम ड्राइवर अपडेट",
            "Get notified about captain's allocation,": "ड्राइवर असाइनमेंट की जानकारी प्राप्त करें,",
            "arrival and more": "आगमन और अन्य अपडेट",
            "Offer and news": "ऑफर और समाचार",
            "Be the first to konw about our offers": "हमारे ऑफर्स के बारे में सबसे पहले जानें",
            "and new features": "और नए फीचर्स",
            "Allow": "अनुमति दें",
            "Maybe, later": "शायद बाद में",
            "Continue Booking": "बुकिंग जारी रखें",
            "Please select pickup and drop location !!": "कृपया पिकअप और ड्रॉप स्थान चुनें !!",
            "Where from?": "कहाँ से?",
            "Where to?": "कहाँ तक?",
            "Fast Pickup": "तेज़ पिकअप",
            "Average wait time under 5 minutes in all major cities.": "सभी प्रमुख शहरों में औसत प्रतीक्षा समय 5 मिनट से कम",
            "Safe Rides": "सुरक्षित राइड",
            "Background checked drivers and SOS features for safety.": "सुरक्षा के लिए बैकग्राउंड चेक किए गए ड्राइवर और SOS फीचर",
            "24/7 Support": "24/7 सहायता",
            "Our dedicated team is always here to help you anywhere.": "हमारी समर्पित टीम हमेशा आपकी मदद के लिए उपलब्ध है",
            "Best Prices": "सबसे बेहतर कीमत",
            "Optimized routes and fair pricing compared to others.": "अन्य की तुलना में बेहतर मार्ग और उचित कीमत",
            "Payment was faild! please try agine": "भुगतान विफल हो गया! कृपया पुनः प्रयास करें",
            "Rides History": "राइड इतिहास",
            "View your completed rides and upcoming bookings.": "अपनी पूरी हुई राइड्स और आने वाली बुकिंग्स देखें",
            "Upcoming": "आगामी",
            "Completed": "पूर्ण",
            "Cancelled": "रद्द",
            "Date": "तारीख",
            "Time": "समय",
            "Estimated Fare": "अनुमानित किराया",
            "PICKUP": "पिकअप",
            "DESTINATION": "गंतव्य",
            "View Details": "विवरण देखें",
            "No Order Found!": "कोई ऑर्डर नहीं मिला!",
            "Currently you don't have order.": "वर्तमान में आपके पास कोई ऑर्डर नहीं है",
            "Review & Rating": "समीक्षा और रेटिंग",
            "How was your ride with": "आपकी राइड कैसी रही",
            "Great, what did you like the mast? 😍": "बहुत बढ़िया! आपको सबसे ज्यादा क्या पसंद आया? 😍",
            "Submit": "सबमिट करें",
            "Skip": "छोड़ें",
            "Driver Profile": "ड्राइवर प्रोफाइल",
            "Rating": "रेटिंग",
            "Trips": "यात्राएं",
            "Joined": "जुड़ा",
            "Since": "से",
            "Verified": "सत्यापित",
            "Reviews": "समीक्षाएं",
            "Languages": "भाषाएं",
            "Preference": "पसंद",
            "Phone Number": "फोन नंबर",
            "Referral code copied!": "रेफरल कोड कॉपी हो गया!",
            "Refer & Earn": "रेफर करें और कमाएं",
            "Share and earn rewards together!": "शेयर करें और साथ में इनाम कमाएं!",
            "Your Referral Code": "आपका रेफरल कोड",
            "Share this code with your friends": "इस कोड को अपने दोस्तों के साथ साझा करें",
            "Copy": "कॉपी करें",
            "WhatsApp": "व्हाट्सएप",
            "SMS": "एसएमएस",
            "More": "और",
            "Share via your favorite social platform": "अपने पसंदीदा सोशल प्लेटफॉर्म पर शेयर करें",
            "How It Works": "यह कैसे काम करता है",
            "Share Your Code": "अपना कोड शेयर करें",
            "Share your unique referral code with friends and family": "अपने यूनिक रेफरल कोड को दोस्तों और परिवार के साथ साझा करें",
            "Friend Signs Up": "दोस्त साइन अप करता है",
            "You Earn Rewards": "आप इनाम कमाते हैं",
            "Everyone Wins!": "सभी जीतते हैं!",
            "Both you and your friend can use the credits for consultations, medicines, and lab tests": "आप और आपका दोस्त दोनों क्रेडिट का उपयोग सेवाओं के लिए कर सकते हैं",
            "My Wallet": "मेरा वॉलेट",
            "Total Balance": "कुल बैलेंस",
            "Add Money": "पैसे जोड़ें",
            "Transaction History": "लेन-देन इतिहास",
            "No transactions yet": "अभी तक कोई लेन-देन नहीं",
            "Your transaction history will appear here": "आपका लेन-देन इतिहास यहां दिखाई देगा",
            "Build better products with flexible tools, helpful documentation": "लचीले टूल्स और उपयोगी डॉक्यूमेंटेशन के साथ बेहतर प्रोडक्ट बनाएं",
            "and a team that champions your growth.": "और एक टीम जो आपकी प्रगति में मदद करती है",
            "Useful Link": "उपयोगी लिंक",
            "Socials": "सोशल लिंक",
            "* Terms and conditions apply. Rewards will be credited after successful signup.": "* नियम और शर्तें लागू। सफल साइनअप के बाद रिवॉर्ड्स जोड़े जाएंगे",
            "Enter Full Name": "पूरा नाम दर्ज करें",
            "Enter Email Address": "ईमेल पता दर्ज करें",
            "Enter Password": "पासवर्ड दर्ज करें",
            "Enter Phone Number": "फोन नंबर दर्ज करें",
            "Credit": "क्रेडिट",
            "Debit": "डेबिट",
            "Update": "अपडेट करें",
            "Please enter amount !!": "कृपया राशि दर्ज करें !!",
            "Please select payment method": "कृपया भुगतान विधि चुनें",
            "Select Paymet Method": "भुगतान विधि चुनें",
            "Add Wallet Amount": "वॉलेट में राशि जोड़ें",
            "Enter amount": "राशि दर्ज करें",
            "refer_credit": "हर सफल रेफरल पर आपको ₹{{refer_credit}} आपके वॉलेट में मिलेंगे",
            "signup_credit": "आपका दोस्त आपके रेफरल कोड से रजिस्टर करके ₹{{signup_credit}} तुरंत प्राप्त करेगा",
            "footer_title": "© {{getFullYear}} ZippyGo. सर्वाधिकार सुरक्षित",
            "Driver Offer": "ड्राइवर ऑफ़र",
            "km": "किमी",
            "min": "मिनट",
            "Decline": "अस्वीकार करें",
            "Accept": "स्वीकार करें",
            "Install Progressive Web Application": "प्रोग्रेसिव वेब ऐप इंस्टॉल करें",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "इस साइट में ऐप जैसी सुविधाएं हैं। बेहतर अनुभव और आसान पहुंच के लिए इसे अपने डिवाइस पर इंस्टॉल करें।",
            "Install": "इंस्टॉल करें"
        }
    },
    ar: {
        translation: {
            "Logout": "تسجيل الخروج",
            "Profile": "الملف الشخصي",
            "My ride": "رحلاتي",
            "Wallet": "المحفظة",
            "Language": "اللغة",
            "Refer and earn": "أحِلّ واربح",
            "Faq": "الأسئلة الشائعة",
            "Notification": "الإشعارات",
            "Logout Successfully !!": "تم تسجيل الخروج بنجاح!",
            "Login": "تسجيل الدخول",
            "Select Language": "اختر اللغة",
            "Please enter phone number !!": "يرجى إدخال رقم الهاتف!",
            "In Valid OTP !!": "رمز التحقق غير صالح!",
            "Please enter passwords !!": "يرجى إدخال كلمة المرور!",
            "Password not match !!": "كلمتا المرور غير متطابقتين!",
            "Forgot Password": "نسيت كلمة المرور",
            "Enter OTP code": "أدخل رمز التحقق",
            "Enter New Pasword": "أدخل كلمة مرور جديدة",
            "Select which contact details should we use to reset your password": "اختر وسيلة الاتصال التي نستخدمها لإعادة تعيين كلمة المرور",
            "OTP hase been sent to your mobile number": "تم إرسال رمز التحقق إلى رقم هاتفك",
            "Please enter your new password": "يرجى إدخال كلمة المرور الجديدة",
            "Phone number": "رقم الهاتف",
            "Enter phone number": "أدخل رقم الهاتف",
            "Search": "بحث",
            "Password": "كلمة المرور",
            "Enter password": "أدخل كلمة المرور",
            "Confirm Password": "تأكيد كلمة المرور",
            "Enter confirm password": "أدخل تأكيد كلمة المرور",
            "Continue": "متابعة",
            "Verify OTP": "تحقق من الرمز",
            "Confirm": "تأكيد",
            "Back": "رجوع",
            "Please enter password !!": "يرجى إدخال كلمة المرور!",
            "Forgot Password?": "هل نسيت كلمة المرور؟",
            "By clicking continue. You agree to our": "بالنقر على متابعة، فإنك توافق على",
            "Terms & Conditions": "الشروط والأحكام",
            "Register Your Account": "إنشاء حسابك",
            "Enter your information below.": "أدخل معلوماتك أدناه.",
            "Full Name": "الاسم الكامل",
            "Email Address": "البريد الإلكتروني",
            "Referral Code": "رمز الإحالة",
            "Enter OTP Code": "أدخل رمز التحقق",
            "Welcome To Your ZippyGo Ride!": "مرحبًا بك في ZippyGo!",
            "Book a ride in just a few taps and reach your destination comfortably.": "احجز رحلتك ببضع نقرات فقط ووصل إلى وجهتك بسهولة.",
            "Please fill all details !!": "يرجى إدخال جميع البيانات!",
            "Enter full name": "أدخل الاسم الكامل",
            "Enter email address": "أدخل البريد الإلكتروني",
            "Enter referral code(optional)": "أدخل رمز الإحالة (اختياري)",
            "Let's Go": "هيا بنا",
            "Why do you want to cancel ?": "لماذا تريد الإلغاء؟",
            "Please provide the reason for cancellation.": "يرجى ذكر سبب الإلغاء.",
            "Are you sure you want to cancel thi ride?": "هل أنت متأكد من إلغاء هذه الرحلة؟",
            "We have found captains near you, please wait for a whilw, your ride should be.": "لقد وجدنا سائقين بالقرب منك، يرجى الانتظار قليلاً.",
            "Yes, Cancel": "نعم، إلغاء",
            "Booking id": "رقم الحجز",
            "Ride Details": "تفاصيل الرحلة",
            "Ride Type": "نوع الرحلة",
            "Car Type": "نوع السيارة",
            "Hours & Minites": "الساعات والدقائق",
            "Hours": "ساعات",
            "Minites": "دقائق",
            "Date & Time": "التاريخ والوقت",
            "Payment Details": "تفاصيل الدفع",
            "Platform Fee": "رسوم المنصة",
            "Km Charge": "تكلفة لكل كم",
            "Additional Time Charge": "رسوم الوقت الإضافي",
            "Minutes": "دقائق",
            "Bid amount": "قيمة العرض",
            "Extra Charge": "رسوم إضافية",
            "Total": "الإجمالي",
            "Invoice": "الفاتورة",
            "Rate your ride": "قيّم رحلتك",
            "Minimum fare is": "الحد الأدنى للأجرة هو",
            "Maximum fare is": "الحد الأقصى للأجرة هو",
            "Finding a ride": "جارٍ البحث عن رحلة",
            "for you": "لك",
            "ride": "رحلة",
            "💡 Raise the fare. increase your chance.": "💡 ارفع الأجرة لزيادة فرصك.",
            "Automatically book the nearest": "احجز تلقائيًا أقرب",
            "driver for": "سائق لـ",
            "Book for": "احجز لـ",
            "Cancel request": "إلغاء الطلب",
            "Pickup": "نقطة الانطلاق",
            "Drop": "الوجهة",
            "Time's up. Extra charges apply": "انتهى الوقت. سيتم تطبيق رسوم إضافية",
            "Start your order with PIN": "ابدأ الرحلة باستخدام الرمز",
            "Total Fare": "إجمالي الأجرة",
            "Paying Via": "الدفع عبر",
            "Cancel Ride": "إلغاء الرحلة",
            "Additional time": "وقت إضافي",
            "minit": "دقيقة",
            "Base Fare": "الأجرة الأساسية",
            "Select Payment Method": "اختر طريقة الدفع",
            "Set your price": "حدد سعرك",
            "Cash": "نقدًا",
            "Coupon": "كوبون",
            "Captain on the way": "السائق في الطريق",
            "Captain has arrived": "وصل السائق",
            "Heading to the destination": "في الطريق إلى الوجهة",
            "+ Add stop": "+ إضافة محطة",
            "Choose your pickup spot": "اختر موقع الانطلاق",
            "Confirm pickup": "تأكيد الانطلاق",
            "Cancel": "إلغاء",
            "Location search": "البحث عن موقع",
            "Set location on map": "تحديد الموقع على الخريطة",
            "Recommended fare": "الأجرة المقترحة",
            "Total Km": "إجمالي الكيلومترات",
            "Total Hours": "إجمالي الساعات",
            "Total Minutes": "إجمالي الدقائق",
            "Weather Charge": "رسوم الطقس",
            "Extra Person Charge": "رسوم شخص إضافي",
            "Day Charge": "رسوم اليوم",
            "Per Hours Charge x 1": "رسوم الساعة × 1",
            "Per Hours Discount": "خصم لكل ساعة",
            "Kg Charge": "رسوم لكل كجم",
            "Tax": "الضريبة",
            "Total Price": "السعر الإجمالي",
            "Find Driver": "ابحث عن سائق",
            "Select Coupon": "اختر كوبون",
            "Coupon Code": "رمز الكوبون",
            "Coupon Amount": "قيمة الكوبون",
            "Minimum Amount": "الحد الأدنى للمبلغ",
            "Ex Date": "تاريخ الانتهاء",
            "Apply Coupon": "تطبيق الكوبون",
            "Remove Coupon": "إزالة الكوبون",
            "Captains are busy": "السائقون مشغولون",
            "Try Again": "حاول مرة أخرى",
            "Package details": "تفاصيل الشحنة",
            "Save": "حفظ",
            "Log in to see ride options": "سجّل الدخول لرؤية خيارات الرحلة",
            "Please take a moment to quickly log in or sign up so we can show you your ride options": "يرجى تسجيل الدخول أو إنشاء حساب لعرض خيارات الرحلة",
            "Please enter data in the previous field first !!": "يرجى إدخال البيانات في الحقل السابق أولاً!",
            "City to city": "من مدينة إلى مدينة",
            "Rental": "إيجار",
            "Freight": "شحن",
            "Pickup location": "موقع الانطلاق",
            "Dropoff location": "موقع الوصول",
            "Stop location": "موقع التوقف",
            "Search location": "ابحث عن موقع",
            "Length": "الطول",
            "Width": "العرض",
            "Height": "الارتفاع",
            "For example: a small box, about 1kg": "على سبيل المثال: صندوق صغير حوالي 1 كجم",
            "max_weight": "الحد الأقصى للوزن {{kg}} كجم",
            "total_kg_placeholder": "إجمالي الكجم (الحد الأقصى {{kg}} كجم)",
            "Select Ride Type": "اختر نوع الرحلة",
            "Select Outstation Services": "اختر خدمات السفر خارج المدينة",
            "Available Vehicle Types": "أنواع المركبات المتاحة",
            "Select Date & Time": "اختر التاريخ والوقت",
            "Number of passengers": "عدد الركاب",
            "Rental Type": "نوع الإيجار",
            "How much time do you need?": "كم من الوقت تحتاج؟",
            "hours": "ساعات",
            "Sender & Recevier info": "معلومات المرسل والمستلم",
            "Vehicle size": "حجم المركبة",
            "Please select pickup location !!": "يرجى اختيار موقع الانطلاق!",
            "Please select dropoff location !!": "يرجى اختيار موقع الوصول!",
            "Please select all details !!": "يرجى اختيار جميع التفاصيل!",
            "Please fill all stop locations !!": "يرجى إدخال جميع مواقع التوقف!",
            "Select date": "اختر التاريخ",
            "Select time": "اختر الوقت",
            "Find a driver": "ابحث عن سائق",
            "Choose a ride": "اختر رحلة",
            "Please fill sender & recevier info !!": "يرجى إدخال معلومات المرسل والمستلم!",
            "Please fill Package details !!": "يرجى إدخال تفاصيل الشحنة!",
            "Create request": "إنشاء طلب",
            "Sender Phone Number": "رقم هاتف المرسل",
            "Recevier Phone Number": "رقم هاتف المستلم",
            "Enter details": "أدخل التفاصيل",
            "max_passenger": "الحد الأقصى للركاب {{count}}",
            "max_hours": "الحد الأقصى للساعات {{count}}",
            "Please write a message !!": "يرجى كتابة رسالة!",
            "Start Conversation...": "ابدأ المحادثة...",
            "Faq Question & Answer": "الأسئلة الشائعة والإجابات",
            "Please select service !!": "يرجى اختيار الخدمة!",
            "Get a ride": "احجز رحلة",
            "Select service": "اختر الخدمة",
            "min away - Drop": "دقائق للوصول - الوجهة",
            "Your ride,": "رحلتك،",
            "your way": "بطريقتك",
            "Experience the next generation of urban mobility. Fast, reliable, and tailored": "استمتع بالجيل الجديد من التنقل الحضري. سريع وموثوق ومصمم",
            "to your daily needs.": "لتلبية احتياجاتك اليومية.",
            "Pickup Location": "موقع الانطلاق",
            "Drop-off Location": "موقع الوصول",
            "Find Ride": "ابحث عن رحلة",
            "Our Services": "خدماتنا",
            "Book now": "احجز الآن",
            "Real-Time Tracking": "تتبع في الوقت الحقيقي",
            "Set Your Pickup": "حدد موقع الانطلاق",
            "Enter your pickup and drop location. Our system instantly finds the nearest driver to you.": "أدخل موقع الانطلاق والوصول، وسيقوم النظام بالعثور على أقرب سائق فورًا.",
            "Driver Matched": "تم تعيين السائق",
            "A verified, top-rated driver is matched to your ride within 30 seconds of booking.": "يتم تعيين سائق موثوق وذو تقييم عالٍ خلال 30 ثانية من الحجز.",
            "Track in Real-Time": "تتبع في الوقت الحقيقي",
            "Watch your driver's live location on the map. Share ETA with friends or family.": "شاهد موقع السائق مباشرة على الخريطة وشارك وقت الوصول مع الآخرين.",
            "Arrive & Pay": "الوصول والدفع",
            "Pay via UPI, card, or cash. Rate your driver and get a digital receipt instantly.": "ادفع عبر UPI أو البطاقة أو نقدًا، وقيّم السائق واحصل على إيصال رقمي فورًا.",
            "Location permission not enabled": "لم يتم تفعيل إذن الموقع",
            "Sharing Location permission helps us improve your ride booking and pickup experience.": "مشاركة الموقع تساعدنا على تحسين تجربة الحجز والانطلاق.",
            "Allow Permission": "السماح بالإذن",
            "Allow Notification and on-ride alerts": "السماح بالإشعارات والتنبيهات",
            "Real-time Captain updates": "تحديثات السائق في الوقت الحقيقي",
            "Get notified about captain's allocation,": "احصل على إشعارات بتعيين السائق،",
            "arrival and more": "والوصول والمزيد",
            "Offer and news": "العروض والأخبار",
            "Be the first to konw about our offers": "كن أول من يعرف عن عروضنا",
            "and new features": "والميزات الجديدة",
            "Allow": "السماح",
            "Maybe, later": "ربما لاحقًا",
            "Continue Booking": "متابعة الحجز",
            "Please select pickup and drop location !!": "يرجى اختيار موقع الانطلاق والوصول!",
            "Where from?": "من أين؟",
            "Where to?": "إلى أين؟",
            "Fast Pickup": "انطلاق سريع",
            "Average wait time under 5 minutes in all major cities.": "متوسط وقت الانتظار أقل من 5 دقائق في معظم المدن.",
            "Safe Rides": "رحلات آمنة",
            "Background checked drivers and SOS features for safety.": "سائقون تم التحقق من خلفياتهم وميزات SOS لزيادة الأمان.",
            "24/7 Support": "دعم على مدار 24/7",
            "Our dedicated team is always here to help you anywhere.": "فريقنا المتخصص موجود دائمًا لمساعدتك في أي مكان.",
            "Best Prices": "أفضل الأسعار",
            "Optimized routes and fair pricing compared to others.": "مسارات محسّنة وأسعار عادلة مقارنةً بالآخرين.",
            "Payment was faild! please try agine": "فشل الدفع! يرجى المحاولة مرة أخرى",
            "Rides History": "سجل الرحلات",
            "View your completed rides and upcoming bookings.": "اطّلع على رحلاتك المكتملة والحجوزات القادمة.",
            "Upcoming": "القادمة",
            "Completed": "المكتملة",
            "Cancelled": "الملغاة",
            "Date": "التاريخ",
            "Time": "الوقت",
            "Estimated Fare": "الأجرة التقديرية",
            "PICKUP": "نقطة الانطلاق",
            "DESTINATION": "الوجهة",
            "View Details": "عرض التفاصيل",
            "No Order Found!": "لم يتم العثور على طلب!",
            "Currently you don't have order.": "لا يوجد لديك طلبات حاليًا.",
            "Review & Rating": "المراجعة والتقييم",
            "How was your ride with": "كيف كانت رحلتك مع",
            "Great, what did you like the mast? 😍": "رائع، ما الذي أعجبك أكثر؟ 😍",
            "Submit": "إرسال",
            "Skip": "تخطي",
            "Driver Profile": "ملف السائق",
            "Rating": "التقييم",
            "Trips": "الرحلات",
            "Joined": "تاريخ الانضمام",
            "Since": "منذ",
            "Verified": "موثق",
            "Reviews": "التقييمات",
            "Languages": "اللغات",
            "Preference": "التفضيلات",
            "Phone Number": "رقم الهاتف",
            "Referral code copied!": "تم نسخ رمز الإحالة!",
            "Refer & Earn": "أحِلّ واربح",
            "Share and earn rewards together!": "شارك واربح المكافآت معًا!",
            "Your Referral Code": "رمز الإحالة الخاص بك",
            "Share this code with your friends": "شارك هذا الرمز مع أصدقائك",
            "Copy": "نسخ",
            "WhatsApp": "واتساب",
            "SMS": "رسالة نصية",
            "More": "المزيد",
            "Share via your favorite social platform": "شارك عبر منصتك الاجتماعية المفضلة",
            "How It Works": "كيف يعمل",
            "Share Your Code": "شارك رمزك",
            "Share your unique referral code with friends and family": "شارك رمز الإحالة الخاص بك مع الأصدقاء والعائلة",
            "Friend Signs Up": "يقوم الصديق بالتسجيل",
            "You Earn Rewards": "تحصل على مكافآت",
            "Everyone Wins!": "الجميع يربح!",
            "Both you and your friend can use the credits for consultations, medicines, and lab tests": "يمكنك أنت وصديقك استخدام الرصيد للاستشارات والأدوية والفحوصات",
            "My Wallet": "محفظتي",
            "Total Balance": "إجمالي الرصيد",
            "Add Money": "إضافة رصيد",
            "Transaction History": "سجل المعاملات",
            "No transactions yet": "لا توجد معاملات حتى الآن",
            "Your transaction history will appear here": "سيظهر سجل معاملاتك هنا",
            "Build better products with flexible tools, helpful documentation": "أنشئ منتجات أفضل باستخدام أدوات مرنة ووثائق مفيدة",
            "and a team that champions your growth.": "وفريق يدعم نموك.",
            "Useful Link": "روابط مفيدة",
            "Socials": "وسائل التواصل",
            "* Terms and conditions apply. Rewards will be credited after successful signup.": "* تطبق الشروط والأحكام. سيتم إضافة المكافآت بعد التسجيل بنجاح.",
            "Enter Full Name": "أدخل الاسم الكامل",
            "Enter Email Address": "أدخل البريد الإلكتروني",
            "Enter Password": "أدخل كلمة المرور",
            "Enter Phone Number": "أدخل رقم الهاتف",
            "Credit": "إيداع",
            "Debit": "سحب",
            "Update": "تحديث",
            "Please enter amount !!": "يرجى إدخال المبلغ!",
            "Please select payment method": "يرجى اختيار طريقة الدفع",
            "Select Paymet Method": "اختر طريقة الدفع",
            "Add Wallet Amount": "إضافة مبلغ إلى المحفظة",
            "Enter amount": "أدخل المبلغ",
            "refer_credit": "تحصل على ₹{{refer_credit}} في محفظتك لكل إحالة ناجحة",
            "signup_credit": "يسجل صديقك باستخدام رمز الإحالة الخاص بك ويحصل على ₹{{signup_credit}} فورًا",
            "footer_title": "© {{getFullYear}} ZippyGo. جميع الحقوق محفوظة.",
            "Driver Offer": "عرض السائق",
            "km": "كم",
            "min": "دقيقة",
            "Decline": "رفض",
            "Accept": "قبول",
            "Install Progressive Web Application": "تثبيت تطبيق الويب التقدمي",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "يحتوي هذا الموقع على وظائف تطبيق. قم بتثبيته على جهازك للحصول على تجربة أفضل وسهولة في الوصول.",
            "Install": "تثبيت"
        }
    },
    gu: {
        translation: {
            "Logout": "લૉગઆઉટ",
            "Profile": "પ્રોફાઇલ",
            "My ride": "મારી સવારી",
            "Wallet": "વૉલેટ",
            "Language": "ભાષા",
            "Refer and earn": "રેફર કરો અને કમાવો",
            "Faq": "વારંવાર પૂછાતા પ્રશ્નો",
            "Notification": "સૂચનાઓ",
            "Logout Successfully !!": "સફળતાપૂર્વક લૉગઆઉટ થયું!",
            "Login": "લૉગિન",
            "Select Language": "ભાષા પસંદ કરો",
            "Please enter phone number !!": "કૃપા કરીને ફોન નંબર દાખલ કરો!",
            "In Valid OTP !!": "અમાન્ય OTP!",
            "Please enter passwords !!": "કૃપા કરીને પાસવર્ડ દાખલ કરો!",
            "Password not match !!": "પાસવર્ડ મેળ ખાતો નથી!",
            "Forgot Password": "પાસવર્ડ ભૂલી ગયા?",
            "Enter OTP code": "OTP કોડ દાખલ કરો",
            "Enter New Pasword": "નવો પાસવર્ડ દાખલ કરો",
            "Select which contact details should we use to reset your password": "પાસવર્ડ રીસેટ કરવા માટે સંપર્ક વિગતો પસંદ કરો",
            "OTP hase been sent to your mobile number": "OTP તમારા મોબાઇલ નંબર પર મોકલવામાં આવ્યો છે",
            "Please enter your new password": "કૃપા કરીને તમારો નવો પાસવર્ડ દાખલ કરો",
            "Phone number": "ફોન નંબર",
            "Enter phone number": "ફોન નંબર દાખલ કરો",
            "Search": "શોધો",
            "Password": "પાસવર્ડ",
            "Enter password": "પાસવર્ડ દાખલ કરો",
            "Confirm Password": "પાસવર્ડની પુષ્ટિ કરો",
            "Enter confirm password": "પાસવર્ડ પુષ્ટિ દાખલ કરો",
            "Continue": "આગળ વધો",
            "Verify OTP": "OTP ચકાસો",
            "Confirm": "પુષ્ટિ કરો",
            "Back": "પાછળ",
            "Please enter password !!": "કૃપા કરીને પાસવર્ડ દાખલ કરો!",
            "Forgot Password?": "પાસવર્ડ ભૂલી ગયા?",
            "By clicking continue. You agree to our": "આગળ વધતા તમે અમારી સાથે સહમત થાઓ છો",
            "Terms & Conditions": "શરતો અને નિયમો",
            "Register Your Account": "તમારું એકાઉન્ટ રજિસ્ટર કરો",
            "Enter your information below.": "નીચે તમારી માહિતી દાખલ કરો.",
            "Full Name": "પૂર્ણ નામ",
            "Email Address": "ઈમેલ સરનામું",
            "Referral Code": "રેફરલ કોડ",
            "Enter OTP Code": "OTP કોડ દાખલ કરો",
            "Welcome To Your ZippyGo Ride!": "તમારી ZippyGo સવારીમાં આપનું સ્વાગત છે!",
            "Book a ride in just a few taps and reach your destination comfortably.": "થોડા ટૅપમાં સવારી બુક કરો અને આરામથી ગંતવ્ય સુધી પહોંચો.",
            "Please fill all details !!": "કૃપા કરીને તમામ વિગતો ભરો!",
            "Enter full name": "પૂર્ણ નામ દાખલ કરો",
            "Enter email address": "ઈમેલ સરનામું દાખલ કરો",
            "Enter referral code(optional)": "રેફરલ કોડ દાખલ કરો (વૈકલ્પિક)",
            "Let's Go": "ચાલો શરૂ કરીએ",
            "Why do you want to cancel ?": "તમે કેમ રદ કરવા માંગો છો?",
            "Please provide the reason for cancellation.": "કૃપા કરીને રદ કરવાની કારણ આપો.",
            "Are you sure you want to cancel thi ride?": "શું તમે આ સવારી રદ કરવા ખાતરી કરો છો?",
            "We have found captains near you, please wait for a whilw, your ride should be.": "અમને તમારા નજીક ડ્રાઇવર મળ્યા છે, કૃપા કરીને થોડી રાહ જુઓ.",
            "Yes, Cancel": "હા, રદ કરો",
            "Booking id": "બુકિંગ આઈડી",
            "Ride Details": "સવારીની વિગતો",
            "Ride Type": "સવારીનો પ્રકાર",
            "Car Type": "કારનો પ્રકાર",
            "Hours & Minites": "કલાક અને મિનિટ",
            "Hours": "કલાક",
            "Minites": "મિનિટ",
            "Date & Time": "તારીખ અને સમય",
            "Payment Details": "ચુકવણીની વિગતો",
            "Platform Fee": "પ્લેટફોર્મ ફી",
            "Km Charge": "કિમી ચાર્જ",
            "Additional Time Charge": "વધારાનો સમય ચાર્જ",
            "Minutes": "મિનિટ",
            "Bid amount": "બિડ રકમ",
            "Extra Charge": "વધારાનો ચાર્જ",
            "Total": "કુલ",
            "Invoice": "ઇન્વોઇસ",
            "Rate your ride": "તમારી સવારીને રેટ કરો",
            "Minimum fare is": "ન્યૂનતમ ભાડું છે",
            "Maximum fare is": "મહત્તમ ભાડું છે",
            "Finding a ride": "સવારી શોધી રહ્યા છીએ",
            "for you": "તમારા માટે",
            "ride": "સવારી",
            "💡 Raise the fare. increase your chance.": "💡 ભાડું વધારો, તમારી તક વધારશો.",
            "Automatically book the nearest": "સ્વચાલિત રીતે નજીકનો",
            "driver for": "ડ્રાઇવર બુક કરો",
            "Book for": "માટે બુક કરો",
            "Cancel request": "વિનંતી રદ કરો",
            "Pickup": "પિકઅપ",
            "Drop": "ડ્રોપ",
            "Time's up. Extra charges apply": "સમય પૂરો થયો. વધારાનો ચાર્જ લાગુ પડશે",
            "Start your order with PIN": "PIN સાથે તમારી સવારી શરૂ કરો",
            "Total Fare": "કુલ ભાડું",
            "Paying Via": "ચુકવણી માધ્યમ",
            "Cancel Ride": "સવારી રદ કરો",
            "Additional time": "વધારાનો સમય",
            "minit": "મિનિટ",
            "Base Fare": "મૂળ ભાડું",
            "Select Payment Method": "ચુકવણી પદ્ધતિ પસંદ કરો",
            "Set your price": "તમારું ભાવ નક્કી કરો",
            "Cash": "નગદ",
            "Coupon": "કૂપન",
            "Captain on the way": "ડ્રાઇવર રસ્તામાં છે",
            "Captain has arrived": "ડ્રાઇવર આવી ગયો છે",
            "Heading to the destination": "ગંતવ્ય તરફ જઈ રહ્યા છે",
            "+ Add stop": "+ સ્ટોપ ઉમેરો",
            "Choose your pickup spot": "તમારું પિકઅપ સ્થાન પસંદ કરો",
            "Confirm pickup": "પિકઅપની પુષ્ટિ કરો",
            "Cancel": "રદ કરો",
            "Location search": "સ્થાન શોધો",
            "Set location on map": "નકશા પર સ્થાન સેટ કરો",
            "Recommended fare": "ભલામણ કરેલ ભાડું",
            "Total Km": "કુલ કિમી",
            "Total Hours": "કુલ કલાક",
            "Total Minutes": "કુલ મિનિટ",
            "Weather Charge": "હવામાન ચાર્જ",
            "Extra Person Charge": "વધારાના વ્યક્તિનો ચાર્જ",
            "Day Charge": "દિવસનો ચાર્જ",
            "Per Hours Charge x 1": "દર કલાકનો ચાર્જ x 1",
            "Per Hours Discount": "દર કલાકનો ડિસ્કાઉન્ટ",
            "Kg Charge": "કિલોગ્રામ દીઠ ચાર્જ",
            "Tax": "કર",
            "Total Price": "કુલ કિંમત",
            "Find Driver": "ડ્રાઇવર શોધો",
            "Select Coupon": "કૂપન પસંદ કરો",
            "Coupon Code": "કૂપન કોડ",
            "Coupon Amount": "કૂપનની રકમ",
            "Minimum Amount": "ન્યૂનતમ રકમ",
            "Ex Date": "સમાપ્તિ તારીખ",
            "Apply Coupon": "કૂપન લાગુ કરો",
            "Remove Coupon": "કૂપન દૂર કરો",
            "Captains are busy": "ડ્રાઇવરો વ્યસ્ત છે",
            "Try Again": "ફરી પ્રયાસ કરો",
            "Package details": "પેકેજની વિગતો",
            "Save": "સાચવો",
            "Log in to see ride options": "સવારી વિકલ્પો જોવા માટે લૉગિન કરો",
            "Please take a moment to quickly log in or sign up so we can show you your ride options": "કૃપા કરીને લૉગિન કરો અથવા સાઇન અપ કરો જેથી અમે તમને સવારી વિકલ્પો બતાવી શકીએ",
            "Please enter data in the previous field first !!": "કૃપા કરીને પહેલા અગાઉના ફીલ્ડમાં માહિતી દાખલ કરો!",
            "City to city": "શહેરથી શહેર",
            "Rental": "ભાડે",
            "Freight": "માલ વાહન",
            "Pickup location": "પિકઅપ સ્થાન",
            "Dropoff location": "ડ્રોપ સ્થાન",
            "Stop location": "સ્ટોપ સ્થાન",
            "Search location": "સ્થાન શોધો",
            "Length": "લંબાઈ",
            "Width": "પહોળાઈ",
            "Height": "ઊંચાઈ",
            "For example: a small box, about 1kg": "ઉદાહરણ તરીકે: નાનું બોક્સ, લગભગ 1 કિલો",
            "max_weight": "મહત્તમ વજન {{kg}} કિલો",
            "total_kg_placeholder": "કુલ કિલો (મહત્તમ {{kg}} કિલો)",
            "Select Ride Type": "સવારીનો પ્રકાર પસંદ કરો",
            "Select Outstation Services": "આઉટસ્ટેશન સેવા પસંદ કરો",
            "Available Vehicle Types": "ઉપલબ્ધ વાહન પ્રકારો",
            "Select Date & Time": "તારીખ અને સમય પસંદ કરો",
            "Number of passengers": "મુસાફરોની સંખ્યા",
            "Rental Type": "ભાડાનો પ્રકાર",
            "How much time do you need?": "તમને કેટલો સમય જોઈએ?",
            "hours": "કલાક",
            "Sender & Recevier info": "મોકલનાર અને પ્રાપ્તકર્તાની માહિતી",
            "Vehicle size": "વાહનનું કદ",
            "Please select pickup location !!": "કૃપા કરીને પિકઅપ સ્થાન પસંદ કરો!",
            "Please select dropoff location !!": "કૃપા કરીને ડ્રોપ સ્થાન પસંદ કરો!",
            "Please select all details !!": "કૃપા કરીને તમામ વિગતો પસંદ કરો!",
            "Please fill all stop locations !!": "કૃપા કરીને તમામ સ્ટોપ સ્થાન ભરો!",
            "Select date": "તારીખ પસંદ કરો",
            "Select time": "સમય પસંદ કરો",
            "Find a driver": "ડ્રાઇવર શોધો",
            "Choose a ride": "સવારી પસંદ કરો",
            "Please fill sender & recevier info !!": "કૃપા કરીને મોકલનાર અને પ્રાપ્તકર્તાની માહિતી ભરો!",
            "Please fill Package details !!": "કૃપા કરીને પેકેજની વિગતો ભરો!",
            "Create request": "વિનંતી બનાવો",
            "Sender Phone Number": "મોકલનારનો ફોન નંબર",
            "Recevier Phone Number": "પ્રાપ્તકર્તાનો ફોન નંબર",
            "Enter details": "વિગતો દાખલ કરો",
            "max_passenger": "મહત્તમ મુસાફરો {{count}}",
            "max_hours": "મહત્તમ કલાકો {{count}}",
            "Please write a message !!": "કૃપા કરીને સંદેશ લખો!",
            "Start Conversation...": "વાતચીત શરૂ કરો...",
            "Faq Question & Answer": "પ્રશ્નો અને જવાબો",
            "Please select service !!": "કૃપા કરીને સેવા પસંદ કરો!",
            "Get a ride": "સવારી મેળવો",
            "Select service": "સેવા પસંદ કરો",
            "min away - Drop": "મિનિટ દૂર - ડ્રોપ",
            "Your ride,": "તમારી સવારી,",
            "your way": "તમારા રીતે",
            "Experience the next generation of urban mobility. Fast, reliable, and tailored": "શહેરી મુસાફરીનો નવો અનુભવ. ઝડપી, વિશ્વસનીય અને અનુકૂળ",
            "to your daily needs.": "તમારી દૈનિક જરૂરિયાત માટે.",
            "Pickup Location": "પિકઅપ સ્થાન",
            "Drop-off Location": "ડ્રોપ સ્થાન",
            "Find Ride": "સવારી શોધો",
            "Our Services": "અમારી સેવાઓ",
            "Book now": "હમણાં બુક કરો",
            "Real-Time Tracking": "રિયલ-ટાઇમ ટ્રેકિંગ",
            "Set Your Pickup": "તમારું પિકઅપ સેટ કરો",
            "Enter your pickup and drop location. Our system instantly finds the nearest driver to you.": "પિકઅપ અને ડ્રોપ સ્થાન દાખલ કરો. સિસ્ટમ તરત નજીકનો ડ્રાઇવર શોધે છે.",
            "Driver Matched": "ડ્રાઇવર મળી ગયો",
            "A verified, top-rated driver is matched to your ride within 30 seconds of booking.": "30 સેકન્ડમાં વિશ્વસનીય અને ટોચના ડ્રાઇવર તમને સોંપવામાં આવે છે.",
            "Track in Real-Time": "રિયલ-ટાઇમ ટ્રેક કરો",
            "Watch your driver's live location on the map. Share ETA with friends or family.": "નકશા પર ડ્રાઇવરનું લાઇવ સ્થાન જુઓ અને ETA શેર કરો.",
            "Arrive & Pay": "પહોંચો અને ચુકવણી કરો",
            "Pay via UPI, card, or cash. Rate your driver and get a digital receipt instantly.": "UPI, કાર્ડ અથવા નગદથી ચૂકવણી કરો અને ડિજિટલ રસીદ મેળવો.",
            "Location permission not enabled": "સ્થાન પરવાનગી સક્રિય નથી",
            "Sharing Location permission helps us improve your ride booking and pickup experience.": "સ્થાન પરવાનગી આપવાથી અનુભવ સુધરે છે.",
            "Allow Permission": "પરવાનગી આપો",
            "Allow Notification and on-ride alerts": "સૂચનાઓ અને એલર્ટને મંજૂરી આપો",
            "Real-time Captain updates": "રિયલ-ટાઇમ ડ્રાઇવર અપડેટ",
            "Get notified about captain's allocation,": "ડ્રાઇવર ફાળવણી વિશે સૂચના મેળવો,",
            "arrival and more": "આગમન અને વધુ",
            "Offer and news": "ઓફર અને સમાચાર",
            "Be the first to konw about our offers": "અમારી ઓફરો વિશે પહેલા જાણો",
            "and new features": "અને નવી સુવિધાઓ",
            "Allow": "મંજૂરી આપો",
            "Maybe, later": "પછી કરીશું",
            "Continue Booking": "બુકિંગ ચાલુ રાખો",
            "Please select pickup and drop location !!": "કૃપા કરીને પિકઅપ અને ડ્રોપ સ્થાન પસંદ કરો!",
            "Where from?": "ક્યાંથી?",
            "Where to?": "ક્યાં સુધી?",
            "Fast Pickup": "ઝડપી પિકઅપ",
            "Average wait time under 5 minutes in all major cities.": "મોટા શહેરોમાં સરેરાશ રાહ સમય 5 મિનિટથી ઓછો છે.",
            "Safe Rides": "સુરક્ષિત સવારી",
            "Background checked drivers and SOS features for safety.": "સુરક્ષા માટે ચકાસાયેલ ડ્રાઇવરો અને SOS સુવિધાઓ ઉપલબ્ધ છે.",
            "24/7 Support": "24/7 સહાય",
            "Our dedicated team is always here to help you anywhere.": "અમારી સમર્પિત ટીમ તમને ક્યાંય પણ મદદ કરવા માટે હંમેશા તૈયાર છે.",
            "Best Prices": "શ્રેષ્ઠ કિંમતો",
            "Optimized routes and fair pricing compared to others.": "ઓપ્ટિમાઇઝ્ડ રૂટ્સ અને અન્યની તુલનામાં યોગ્ય કિંમતો.",
            "Payment was faild! please try agine": "ચુકવણી નિષ્ફળ ગઈ! કૃપા કરીને ફરી પ્રયાસ કરો",
            "Rides History": "સવારી ઇતિહાસ",
            "View your completed rides and upcoming bookings.": "તમારી પૂર્ણ થયેલી સવારી અને આવનારી બુકિંગ જુઓ.",
            "Upcoming": "આવનારી",
            "Completed": "પૂર્ણ થયેલી",
            "Cancelled": "રદ થયેલી",
            "Date": "તારીખ",
            "Time": "સમય",
            "Estimated Fare": "અંદાજિત ભાડું",
            "PICKUP": "પિકઅપ",
            "DESTINATION": "ગંતવ્ય",
            "View Details": "વિગતો જુઓ",
            "No Order Found!": "કોઈ ઓર્ડર મળ્યો નથી!",
            "Currently you don't have order.": "હાલમાં તમારા પાસે કોઈ ઓર્ડર નથી.",
            "Review & Rating": "સમિક્ષા અને રેટિંગ",
            "How was your ride with": "તમારી સવારી કેવી રહી",
            "Great, what did you like the mast? 😍": "સરસ! તમને સૌથી વધુ શું ગમ્યું? 😍",
            "Submit": "સબમિટ કરો",
            "Skip": "સ્કિપ કરો",
            "Driver Profile": "ડ્રાઇવર પ્રોફાઇલ",
            "Rating": "રેટિંગ",
            "Trips": "ટ્રિપ્સ",
            "Joined": "જોડાયા",
            "Since": "થી",
            "Verified": "ચકાસાયેલ",
            "Reviews": "સમીક્ષાઓ",
            "Languages": "ભાષાઓ",
            "Preference": "પસંદગીઓ",
            "Phone Number": "ફોન નંબર",
            "Referral code copied!": "રેફરલ કોડ કૉપિ થયો!",
            "Refer & Earn": "રેફર કરો અને કમાવો",
            "Share and earn rewards together!": "શેર કરો અને સાથે મળીને ઇનામ મેળવો!",
            "Your Referral Code": "તમારો રેફરલ કોડ",
            "Share this code with your friends": "આ કોડ તમારા મિત્રો સાથે શેર કરો",
            "Copy": "કૉપિ કરો",
            "WhatsApp": "વોટ્સએપ",
            "SMS": "એસએમએસ",
            "More": "વધુ",
            "Share via your favorite social platform": "તમારી મનપસંદ સોશિયલ પ્લેટફોર્મ દ્વારા શેર કરો",
            "How It Works": "આ કેવી રીતે કાર્ય કરે છે",
            "Share Your Code": "તમારો કોડ શેર કરો",
            "Share your unique referral code with friends and family": "તમારો અનન્ય રેફરલ કોડ મિત્રો અને પરિવાર સાથે શેર કરો",
            "Friend Signs Up": "મિત્ર સાઇન અપ કરે છે",
            "You Earn Rewards": "તમે ઇનામ મેળવો",
            "Everyone Wins!": "બધા જીતે છે!",
            "Both you and your friend can use the credits for consultations, medicines, and lab tests": "તમે અને તમારો મિત્ર બંને આ ક્રેડિટનો ઉપયોગ સલાહ, દવાઓ અને ટેસ્ટ માટે કરી શકો છો",
            "My Wallet": "મારું વૉલેટ",
            "Total Balance": "કુલ બેલેન્સ",
            "Add Money": "પૈસા ઉમેરો",
            "Transaction History": "ટ્રાન્ઝેક્શન ઇતિહાસ",
            "No transactions yet": "હજુ સુધી કોઈ ટ્રાન્ઝેક્શન નથી",
            "Your transaction history will appear here": "તમારો ટ્રાન્ઝેક્શન ઇતિહાસ અહીં દેખાશે",
            "Build better products with flexible tools, helpful documentation": "લવચીક ટૂલ્સ અને ઉપયોગી દસ્તાવેજીકરણ સાથે વધુ સારા પ્રોડક્ટ બનાવો",
            "and a team that champions your growth.": "અને એક ટીમ જે તમારા વિકાસને આગળ વધારે છે.",
            "Useful Link": "ઉપયોગી લિંક્સ",
            "Socials": "સોશિયલ",
            "* Terms and conditions apply. Rewards will be credited after successful signup.": "* નિયમો અને શરતો લાગુ પડે છે. સફળ સાઇનઅપ પછી ઇનામ મળશે.",
            "Enter Full Name": "પૂર્ણ નામ દાખલ કરો",
            "Enter Email Address": "ઈમેલ સરનામું દાખલ કરો",
            "Enter Password": "પાસવર્ડ દાખલ કરો",
            "Enter Phone Number": "ફોન નંબર દાખલ કરો",
            "Credit": "ક્રેડિટ",
            "Debit": "ડેબિટ",
            "Update": "અપડેટ કરો",
            "Please enter amount !!": "કૃપા કરીને રકમ દાખલ કરો!",
            "Please select payment method": "કૃપા કરીને ચુકવણી પદ્ધતિ પસંદ કરો",
            "Select Paymet Method": "ચુકવણી પદ્ધતિ પસંદ કરો",
            "Add Wallet Amount": "વૉલેટમાં રકમ ઉમેરો",
            "Enter amount": "રકમ દાખલ કરો",
            "refer_credit": "દરેક સફળ રેફરલ માટે તમને તમારા વૉલેટમાં ₹{{refer_credit}} મળશે",
            "signup_credit": "તમારો મિત્ર તમારા રેફરલ કોડથી સાઇનઅપ કરે છે અને તરત ₹{{signup_credit}} મેળવે છે",
            "footer_title": "© {{getFullYear}} ZippyGo. સર્વ હક્કો સુરક્ષિત.",
            "Driver Offer": "ડ્રાઈવર ઓફર",
            "km": "કિમી",
            "min": "મિનિટ",
            "Decline": "નકારો",
            "Accept": "સ્વીકારો",
            "Install Progressive Web Application": "પ્રોગ્રેસિવ વેબ એપ્લિકેશન ઇન્સ્ટોલ કરો",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "આ સાઇટમાં એપ જેવી સુવિધાઓ છે. વધુ સારી અનુભૂતિ અને સરળ ઍક્સેસ માટે તેને તમારા ડિવાઇસ પર ઇન્સ્ટોલ કરો.",
            "Install": "ઇન્સ્ટોલ કરો"
        }
    },
    af: {
        translation: {
            "Logout": "Teken uit",
            "Profile": "Profiel",
            "My ride": "My rit",
            "Wallet": "Beursie",
            "Language": "Taal",
            "Refer and earn": "Verwys en verdien",
            "Faq": "Gereelde vrae",
            "Notification": "Kennisgewings",
            "Logout Successfully !!": "Suksesvol uitgeteken !!",
            "Login": "Teken in",
            "Select Language": "Kies taal",
            "Please enter phone number !!": "Voer asseblief telefoonnommer in !!",
            "In Valid OTP !!": "Ongeldige OTP !!",
            "Please enter passwords !!": "Voer asseblief wagwoorde in !!",
            "Password not match !!": "Wagwoorde stem nie ooreen nie !!",
            "Forgot Password": "Wagwoord vergeet",
            "Enter OTP code": "Voer OTP-kode in",
            "Enter New Pasword": "Voer nuwe wagwoord in",
            "Select which contact details should we use to reset your password": "Kies watter kontakbesonderhede ons moet gebruik om jou wagwoord te herstel",
            "OTP hase been sent to your mobile number": "OTP is na jou selfoonnommer gestuur",
            "Please enter your new password": "Voer asseblief jou nuwe wagwoord in",
            "Phone number": "Telefoonnommer",
            "Enter phone number": "Voer telefoonnommer in",
            "Search": "Soek",
            "Password": "Wagwoord",
            "Enter password": "Voer wagwoord in",
            "Confirm Password": "Bevestig wagwoord",
            "Enter confirm password": "Voer bevestigingswagwoord in",
            "Continue": "Gaan voort",
            "Verify OTP": "Verifieer OTP",
            "Confirm": "Bevestig",
            "Back": "Terug",
            "Please enter password !!": "Voer asseblief wagwoord in !!",
            "Forgot Password?": "Wagwoord vergeet?",
            "By clicking continue. You agree to our": "Deur voort te gaan, stem jy in tot ons",
            "Terms & Conditions": "Bepalings en voorwaardes",
            "Register Your Account": "Registreer jou rekening",
            "Enter your information below.": "Voer jou inligting hieronder in.",
            "Full Name": "Volle naam",
            "Email Address": "E-posadres",
            "Referral Code": "Verwysingskode",
            "Enter OTP Code": "Voer OTP-kode in",
            "Welcome To Your ZippyGo Ride!": "Welkom by jou ZippyGo rit!",
            "Book a ride in just a few taps and reach your destination comfortably.": "Bespreek 'n rit met net 'n paar tikke en bereik jou bestemming gemaklik.",
            "Please fill all details !!": "Vul asseblief alle besonderhede in !!",
            "Enter full name": "Voer volle naam in",
            "Enter email address": "Voer e-posadres in",
            "Enter referral code(optional)": "Voer verwysingskode in (opsioneel)",
            "Let's Go": "Kom ons gaan",
            "Why do you want to cancel ?": "Hoekom wil jy kanselleer?",
            "Please provide the reason for cancellation.": "Verskaf asseblief die rede vir kansellasie.",
            "Are you sure you want to cancel thi ride?": "Is jy seker jy wil hierdie rit kanselleer?",
            "We have found captains near you, please wait for a whilw, your ride should be.": "Ons het bestuurders naby jou gevind, wag asseblief 'n rukkie, jou rit behoort binnekort te wees.",
            "Yes, Cancel": "Ja, kanselleer",
            "Booking id": "Bespreking-ID",
            "Ride Details": "Ritbesonderhede",
            "Ride Type": "Rit tipe",
            "Car Type": "Motortipe",
            "Hours & Minites": "Ure en minute",
            "Hours": "Ure",
            "Minites": "Minute",
            "Date & Time": "Datum en tyd",
            "Payment Details": "Betalingsbesonderhede",
            "Platform Fee": "Platformfooi",
            "Km Charge": "Km-koste",
            "Additional Time Charge": "Bykomende tydkoste",
            "Minutes": "Minute",
            "Bid amount": "Biedbedrag",
            "Extra Charge": "Ekstra koste",
            "Total": "Totaal",
            "Invoice": "Faktuur",
            "Rate your ride": "Evalueer jou rit",
            "Minimum fare is": "Minimum tarief is",
            "Maximum fare is": "Maksimum tarief is",
            "Finding a ride": "Soek 'n rit",
            "for you": "vir jou",
            "ride": "rit",
            "💡 Raise the fare. increase your chance.": "💡 Verhoog die tarief. verhoog jou kans.",
            "Automatically book the nearest": "Bespreek outomaties die naaste",
            "driver for": "bestuurder vir",
            "Book for": "Bespreek vir",
            "Cancel request": "Kanselleer versoek",
            "Pickup": "Oplaai",
            "Drop": "Aflaai",
            "Time's up. Extra charges apply": "Tyd is verstreke. Ekstra koste geld",
            "Start your order with PIN": "Begin jou bestelling met PIN",
            "Total Fare": "Totale tarief",
            "Paying Via": "Betaal via",
            "Cancel Ride": "Kanselleer rit",
            "Additional time": "Bykomende tyd",
            "minit": "minuut",
            "Base Fare": "Basistarief",
            "Select Payment Method": "Kies betaalmetode",
            "Set your price": "Stel jou prys",
            "Cash": "Kontant",
            "Coupon": "Koepon",
            "Captain on the way": "Bestuurder op pad",
            "Captain has arrived": "Bestuurder het gearriveer",
            "Heading to the destination": "Op pad na die bestemming",
            "+ Add stop": "+ Voeg stop by",
            "Choose your pickup spot": "Kies jou oplaai plek",
            "Confirm pickup": "Bevestig oplaai",
            "Cancel": "Kanselleer",
            "Location search": "Liggingsoektog",
            "Set location on map": "Stel ligging op kaart",
            "Recommended fare": "Aanbevole tarief",
            "Total Km": "Totale km",
            "Total Hours": "Totale ure",
            "Total Minutes": "Totale minute",
            "Weather Charge": "Weerkoste",
            "Extra Person Charge": "Ekstra persoon koste",
            "Day Charge": "Dagfooi",
            "Per Hours Charge x 1": "Per uur koste x 1",
            "Per Hours Discount": "Per uur afslag",
            "Kg Charge": "Kg-koste",
            "Tax": "Belasting",
            "Total Price": "Totale prys",
            "Find Driver": "Vind bestuurder",
            "Select Coupon": "Kies koepon",
            "Coupon Code": "Koeponkode",
            "Coupon Amount": "Koeponbedrag",
            "Minimum Amount": "Minimum bedrag",
            "Ex Date": "Vervaldatum",
            "Apply Coupon": "Pas koepon toe",
            "Remove Coupon": "Verwyder koepon",
            "Captains are busy": "Bestuurders is besig",
            "Try Again": "Probeer weer",
            "Package details": "Pakketbesonderhede",
            "Save": "Stoor",
            "Log in to see ride options": "Teken in om ritopsies te sien",
            "Please take a moment to quickly log in or sign up so we can show you your ride options": "Neem asseblief 'n oomblik om vinnig aan te meld of te registreer sodat ons jou ritopsies kan wys",
            "Please enter data in the previous field first !!": "Voer asseblief eers data in die vorige veld in !!",
            "City to city": "Stad tot stad",
            "Rental": "Huur",
            "Freight": "Vrag",
            "Pickup location": "Oplaailigging",
            "Dropoff location": "Aflaailigging",
            "Stop location": "Stopligging",
            "Search location": "Soek ligging",
            "Length": "Lengte",
            "Width": "Breedte",
            "Height": "Hoogte",
            "For example: a small box, about 1kg": "Byvoorbeeld: 'n klein boks, ongeveer 1kg",
            "max_weight": "Maksimum {{kg}} kg",
            "total_kg_placeholder": "Totale kg (Maksimum {{kg}} kg)",
            "Select Ride Type": "Kies rittipe",
            "Select Outstation Services": "Kies buitedorp dienste",
            "Available Vehicle Types": "Beskikbare voertuig tipes",
            "Select Date & Time": "Kies datum en tyd",
            "Number of passengers": "Aantal passasiers",
            "Rental Type": "Huur tipe",
            "How much time do you need?": "Hoeveel tyd het jy nodig?",
            "hours": "ure",
            "Sender & Recevier info": "Sender & ontvanger inligting",
            "Vehicle size": "Voertuiggrootte",
            "Please select pickup location !!": "Kies asseblief oplaailigging !!",
            "Please select dropoff location !!": "Kies asseblief aflaailigging !!",
            "Please select all details !!": "Kies asseblief alle besonderhede !!",
            "Please fill all stop locations !!": "Vul asseblief alle stopliggings in !!",
            "Select date": "Kies datum",
            "Select time": "Kies tyd",
            "Find a driver": "Vind 'n bestuurder",
            "Choose a ride": "Kies 'n rit",
            "Please fill sender & recevier info !!": "Vul asseblief sender en ontvanger inligting in !!",
            "Please fill Package details !!": "Vul asseblief pakketbesonderhede in !!",
            "Create request": "Skep versoek",
            "Sender Phone Number": "Sender telefoonnommer",
            "Recevier Phone Number": "Ontvanger telefoonnommer",
            "Enter details": "Voer besonderhede in",
            "max_passenger": "Maksimum passasier kapasiteit {{count}}",
            "max_hours": "Maksimum ure {{count}}",
            "Please write a message !!": "Skryf asseblief 'n boodskap !!",
            "Start Conversation...": "Begin gesprek...",
            "Faq Question & Answer": "Gereelde vrae: Vraag en antwoord",
            "Please select service !!": "Kies asseblief diens !!",
            "Get a ride": "Kry 'n rit",
            "Select service": "Kies diens",
            "min away - Drop": "min weg - Aflaai",
            "Your ride,": "Jou rit,",
            "your way": "jou manier",
            "Experience the next generation of urban mobility. Fast, reliable, and tailored": "Ervaar die volgende generasie stedelike mobiliteit. Vinnig, betroubaar en aangepas",
            "to your daily needs.": "by jou daaglikse behoeftes.",
            "Pickup Location": "Oplaailigging",
            "Drop-off Location": "Aflaailigging",
            "Find Ride": "Vind rit",
            "Our Services": "Ons dienste",
            "Book now": "Bespreek nou",
            "Real-Time Tracking": "Regstreekse opsporing",
            "Set Your Pickup": "Stel jou oplaai",
            "Enter your pickup and drop location. Our system instantly finds the nearest driver to you.": "Voer jou oplaai- en aflaailigging in. Ons stelsel vind onmiddellik die naaste bestuurder vir jou.",
            "Driver Matched": "Bestuurder gekoppel",
            "A verified, top-rated driver is matched to your ride within 30 seconds of booking.": "'n Geverifieerde, top-gegradeerde bestuurder word binne 30 sekondes na jou rit gekoppel.",
            "Track in Real-Time": "Volg in regstreekse tyd",
            "Watch your driver's live location on the map. Share ETA with friends or family.": "Kyk na jou bestuurder se regstreekse ligging op die kaart. Deel ETA met vriende of familie.",
            "Arrive & Pay": "Kom aan & betaal",
            "Pay via UPI, card, or cash. Rate your driver and get a digital receipt instantly.": "Betaal via UPI, kaart of kontant. Evalueer jou bestuurder en kry onmiddellik 'n digitale kwitansie.",
            "Location permission not enabled": "Liggingstoestemming nie geaktiveer nie",
            "Sharing Location permission helps us improve your ride booking and pickup experience.": "Deel van liggingstoestemming help ons om jou ritbespreking en oplaai-ervaring te verbeter.",
            "Allow Permission": "Laat toestemming toe",
            "Allow Notification and on-ride alerts": "Laat kennisgewings en ritwaarskuwings toe",
            "Real-time Captain updates": "Regstreekse bestuurder opdaterings",
            "Get notified about captain's allocation,": "Kry kennisgewings oor bestuurder toewysing,",
            "arrival and more": "aankoms en meer",
            "Offer and news": "Aanbiedinge en nuus",
            "Be the first to konw about our offers": "Wees die eerste om van ons aanbiedinge te weet",
            "and new features": "en nuwe funksies",
            "Allow": "Laat toe",
            "Maybe, later": "Miskien later",
            "Continue Booking": "Gaan voort met bespreking",
            "Please select pickup and drop location !!": "Kies asseblief oplaai- en aflaailigging !!",
            "Where from?": "Van waar?",
            "Where to?": "Na waar?",
            "Fast Pickup": "Vinnige oplaai",
            "Average wait time under 5 minutes in all major cities.": "Gemiddelde wagtyd onder 5 minute in alle groot stede.",
            "Safe Rides": "Veilige ritte",
            "Background checked drivers and SOS features for safety.": "Bestuurders met agtergrondkontroles en SOS-funksies vir veiligheid.",
            "24/7 Support": "24/7 Ondersteuning",
            "Our dedicated team is always here to help you anywhere.": "Ons toegewyde span is altyd hier om jou enige plek te help.",
            "Best Prices": "Beste pryse",
            "Optimized routes and fair pricing compared to others.": "Geoptimaliseerde roetes en billike pryse in vergelyking met ander.",
            "Payment was faild! please try agine": "Betaling het misluk! probeer asseblief weer",
            "Rides History": "Ritgeskiedenis",
            "View your completed rides and upcoming bookings.": "Bekyk jou voltooide ritte en komende besprekings.",
            "Upcoming": "Komend",
            "Completed": "Voltooi",
            "Cancelled": "Gekanselleer",
            "Date": "Datum",
            "Time": "Tyd",
            "Estimated Fare": "Geskatte tarief",
            "PICKUP": "OPLAAI",
            "DESTINATION": "BESTEMMING",
            "View Details": "Bekyk besonderhede",
            "No Order Found!": "Geen bestelling gevind nie!",
            "Currently you don't have order.": "Jy het tans geen bestelling nie.",
            "Review & Rating": "Resensie en gradering",
            "How was your ride with": "Hoe was jou rit met",
            "Great, what did you like the mast? 😍": "Puik, waarvan het jy die meeste gehou? 😍",
            "Submit": "Dien in",
            "Skip": "Slaan oor",
            "Driver Profile": "Bestuurder profiel",
            "Rating": "Gradering",
            "Trips": "Ritte",
            "Joined": "Aangesluit",
            "Since": "Sedert",
            "Verified": "Geverifieer",
            "Reviews": "Resensies",
            "Languages": "Tale",
            "Preference": "Voorkeur",
            "Phone Number": "Telefoonnommer",
            "Referral code copied!": "Verwysingskode gekopieer!",
            "Refer & Earn": "Verwys en verdien",
            "Share and earn rewards together!": "Deel en verdien belonings saam!",
            "Your Referral Code": "Jou verwysingskode",
            "Share this code with your friends": "Deel hierdie kode met jou vriende",
            "Copy": "Kopieer",
            "WhatsApp": "WhatsApp",
            "SMS": "SMS",
            "More": "Meer",
            "Share via your favorite social platform": "Deel via jou gunsteling sosiale platform",
            "How It Works": "Hoe dit werk",
            "Share Your Code": "Deel jou kode",
            "Share your unique referral code with friends and family": "Deel jou unieke verwysingskode met vriende en familie",
            "Friend Signs Up": "Vriend registreer",
            "You Earn Rewards": "Jy verdien belonings",
            "Everyone Wins!": "Almal wen!",
            "Both you and your friend can use the credits for consultations, medicines, and lab tests": "Jy en jou vriend kan die krediete gebruik vir konsultasies, medisyne en laboratoriumtoetse",
            "My Wallet": "My beursie",
            "Total Balance": "Totale balans",
            "Add Money": "Voeg geld by",
            "Transaction History": "Transaksiegeskiedenis",
            "No transactions yet": "Nog geen transaksies nie",
            "Your transaction history will appear here": "Jou transaksiegeskiedenis sal hier verskyn",
            "Build better products with flexible tools, helpful documentation": "Bou beter produkte met buigsame gereedskap en nuttige dokumentasie",
            "and a team that champions your growth.": "en 'n span wat jou groei ondersteun.",
            "Useful Link": "Nuttige skakel",
            "Socials": "Sosiale netwerke",
            "* Terms and conditions apply. Rewards will be credited after successful signup.": "* Bepalings en voorwaardes geld. Belonings sal gekrediteer word na suksesvolle registrasie.",
            "Enter Full Name": "Voer volle naam in",
            "Enter Email Address": "Voer e-posadres in",
            "Enter Password": "Voer wagwoord in",
            "Enter Phone Number": "Voer telefoonnommer in",
            "Credit": "Krediet",
            "Debit": "Debiet",
            "Update": "Opdateer",
            "Please enter amount !!": "Voer asseblief bedrag in !!",
            "Please select payment method": "Kies asseblief betaalmetode",
            "Select Paymet Method": "Kies betaalmetode",
            "Add Wallet Amount": "Voeg beursiebedrag by",
            "Enter amount": "Voer bedrag in",
            "refer_credit": "Jy ontvang ₹{{refer_credit}} in jou beursie vir elke suksesvolle verwysing",
            "signup_credit": "Jou vriend registreer met jou verwysingskode en kry onmiddellik ₹{{signup_credit}}",
            "footer_title": "© {{getFullYear}} ZippyGo. Alle regte voorbehou.",
            "Driver Offer": "Bestuurder-aanbod",
            "km": "km",
            "min": "min",
            "Decline": "Weier",
            "Accept": "Aanvaar",
            "Install Progressive Web Application": "Installeer Progressiewe Webtoepassing",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "Hierdie webwerf het toepassing-funksionaliteit. Installeer dit op jou toestel vir 'n beter ervaring en maklike toegang.",
            "Install": "Installeer"
        }
    },
    be: {
        translation: {
            "Logout": "লগ আউট",
            "Profile": "প্রোফাইল",
            "My ride": "আমার রাইড",
            "Wallet": "ওয়ালেট",
            "Language": "ভাষা",
            "Refer and earn": "রেফার করে আয় করুন",
            "Faq": "প্রশ্নোত্তর",
            "Notification": "নোটিফিকেশন",
            "Logout Successfully !!": "সফলভাবে লগ আউট হয়েছে !!",
            "Login": "লগ ইন",
            "Select Language": "ভাষা নির্বাচন করুন",
            "Please enter phone number !!": "দয়া করে ফোন নম্বর লিখুন !!",
            "In Valid OTP !!": "অবৈধ OTP !!",
            "Please enter passwords !!": "দয়া করে পাসওয়ার্ড লিখুন !!",
            "Password not match !!": "পাসওয়ার্ড মিলছে না !!",
            "Forgot Password": "পাসওয়ার্ড ভুলে গেছেন",
            "Enter OTP code": "OTP কোড লিখুন",
            "Enter New Pasword": "নতুন পাসওয়ার্ড লিখুন",
            "Select which contact details should we use to reset your password": "আপনার পাসওয়ার্ড রিসেট করতে কোন যোগাযোগের তথ্য ব্যবহার করব তা নির্বাচন করুন",
            "OTP hase been sent to your mobile number": "OTP আপনার মোবাইল নম্বরে পাঠানো হয়েছে",
            "Please enter your new password": "দয়া করে আপনার নতুন পাসওয়ার্ড লিখুন",
            "Phone number": "ফোন নম্বর",
            "Enter phone number": "ফোন নম্বর লিখুন",
            "Search": "অনুসন্ধান",
            "Password": "পাসওয়ার্ড",
            "Enter password": "পাসওয়ার্ড লিখুন",
            "Confirm Password": "পাসওয়ার্ড নিশ্চিত করুন",
            "Enter confirm password": "নিশ্চিত পাসওয়ার্ড লিখুন",
            "Continue": "চালিয়ে যান",
            "Verify OTP": "OTP যাচাই করুন",
            "Confirm": "নিশ্চিত করুন",
            "Back": "ফিরে যান",
            "Please enter password !!": "দয়া করে পাসওয়ার্ড লিখুন !!",
            "Forgot Password?": "পাসওয়ার্ড ভুলে গেছেন?",
            "By clicking continue. You agree to our": "চালিয়ে যেতে ক্লিক করে আপনি আমাদের সাথে সম্মত হচ্ছেন",
            "Terms & Conditions": "শর্তাবলী",
            "Register Your Account": "আপনার অ্যাকাউন্ট নিবন্ধন করুন",
            "Enter your information below.": "নিচে আপনার তথ্য লিখুন।",
            "Full Name": "পূর্ণ নাম",
            "Email Address": "ইমেইল ঠিকানা",
            "Referral Code": "রেফারেল কোড",
            "Enter OTP Code": "OTP কোড লিখুন",
            "Welcome To Your ZippyGo Ride!": "আপনার ZippyGo রাইডে স্বাগতম!",
            "Book a ride in just a few taps and reach your destination comfortably.": "মাত্র কয়েকটি ট্যাপে রাইড বুক করুন এবং আরামে আপনার গন্তব্যে পৌঁছান।",
            "Please fill all details !!": "দয়া করে সব তথ্য পূরণ করুন !!",
            "Enter full name": "পূর্ণ নাম লিখুন",
            "Enter email address": "ইমেইল ঠিকানা লিখুন",
            "Enter referral code(optional)": "রেফারেল কোড লিখুন (ঐচ্ছিক)",
            "Let's Go": "চলুন শুরু করি",
            "Why do you want to cancel ?": "আপনি কেন বাতিল করতে চান?",
            "Please provide the reason for cancellation.": "দয়া করে বাতিলের কারণ জানান।",
            "Are you sure you want to cancel thi ride?": "আপনি কি নিশ্চিত এই রাইড বাতিল করতে চান?",
            "We have found captains near you, please wait for a whilw, your ride should be.": "আমরা আপনার কাছাকাছি ড্রাইভার খুঁজে পেয়েছি, দয়া করে কিছুক্ষণ অপেক্ষা করুন।",
            "Yes, Cancel": "হ্যাঁ, বাতিল করুন",
            "Booking id": "বুকিং আইডি",
            "Ride Details": "রাইডের বিবরণ",
            "Ride Type": "রাইডের ধরন",
            "Car Type": "গাড়ির ধরন",
            "Hours & Minites": "ঘণ্টা ও মিনিট",
            "Hours": "ঘণ্টা",
            "Minites": "মিনিট",
            "Date & Time": "তারিখ ও সময়",
            "Payment Details": "পেমেন্ট বিবরণ",
            "Platform Fee": "প্ল্যাটফর্ম ফি",
            "Km Charge": "কিমি চার্জ",
            "Additional Time Charge": "অতিরিক্ত সময় চার্জ",
            "Minutes": "মিনিট",
            "Bid amount": "বিডের পরিমাণ",
            "Extra Charge": "অতিরিক্ত চার্জ",
            "Total": "মোট",
            "Invoice": "ইনভয়েস",
            "Rate your ride": "আপনার রাইড রেট করুন",
            "Minimum fare is": "সর্বনিম্ন ভাড়া",
            "Maximum fare is": "সর্বোচ্চ ভাড়া",
            "Finding a ride": "রাইড খোঁজা হচ্ছে",
            "for you": "আপনার জন্য",
            "ride": "রাইড",
            "💡 Raise the fare. increase your chance.": "💡 ভাড়া বাড়ান, আপনার সম্ভাবনা বাড়বে।",
            "Automatically book the nearest": "স্বয়ংক্রিয়ভাবে নিকটতম বুক করুন",
            "driver for": "ড্রাইভার",
            "Book for": "বুক করুন",
            "Cancel request": "অনুরোধ বাতিল",
            "Pickup": "পিকআপ",
            "Drop": "ড্রপ",
            "Time's up. Extra charges apply": "সময় শেষ। অতিরিক্ত চার্জ প্রযোজ্য",
            "Start your order with PIN": "PIN দিয়ে আপনার অর্ডার শুরু করুন",
            "Total Fare": "মোট ভাড়া",
            "Paying Via": "পরিশোধের মাধ্যম",
            "Cancel Ride": "রাইড বাতিল করুন",
            "Additional time": "অতিরিক্ত সময়",
            "minit": "মিনিট",
            "Base Fare": "বেস ভাড়া",
            "Select Payment Method": "পেমেন্ট পদ্ধতি নির্বাচন করুন",
            "Set your price": "আপনার মূল্য নির্ধারণ করুন",
            "Cash": "নগদ",
            "Coupon": "কুপন",
            "Captain on the way": "ড্রাইভার পথে আছে",
            "Captain has arrived": "ড্রাইভার এসে গেছে",
            "Heading to the destination": "গন্তব্যের দিকে যাচ্ছে",
            "+ Add stop": "+ স্টপ যোগ করুন",
            "Choose your pickup spot": "আপনার পিকআপ স্থান নির্বাচন করুন",
            "Confirm pickup": "পিকআপ নিশ্চিত করুন",
            "Cancel": "বাতিল",
            "Location search": "লোকেশন অনুসন্ধান",
            "Set location on map": "ম্যাপে লোকেশন সেট করুন",
            "Recommended fare": "প্রস্তাবিত ভাড়া",
            "Total Km": "মোট কিমি",
            "Total Hours": "মোট ঘণ্টা",
            "Total Minutes": "মোট মিনিট",
            "Weather Charge": "আবহাওয়া চার্জ",
            "Extra Person Charge": "অতিরিক্ত ব্যক্তির চার্জ",
            "Day Charge": "দিনের চার্জ",
            "Per Hours Charge x 1": "প্রতি ঘণ্টার চার্জ x 1",
            "Per Hours Discount": "প্রতি ঘণ্টার ছাড়",
            "Kg Charge": "কেজি চার্জ",
            "Tax": "কর",
            "Total Price": "মোট মূল্য",
            "Find Driver": "ড্রাইভার খুঁজুন",
            "Select Coupon": "কুপন নির্বাচন করুন",
            "Coupon Code": "কুপন কোড",
            "Coupon Amount": "কুপনের পরিমাণ",
            "Minimum Amount": "সর্বনিম্ন পরিমাণ",
            "Ex Date": "মেয়াদ শেষের তারিখ",
            "Apply Coupon": "কুপন প্রয়োগ করুন",
            "Remove Coupon": "কুপন সরান",
            "Captains are busy": "ড্রাইভাররা ব্যস্ত",
            "Try Again": "আবার চেষ্টা করুন",
            "Package details": "প্যাকেজের বিবরণ",
            "Save": "সংরক্ষণ করুন",
            "Log in to see ride options": "রাইডের অপশন দেখতে লগ ইন করুন",
            "Please take a moment to quickly log in or sign up so we can show you your ride options": "দয়া করে দ্রুত লগ ইন বা সাইন আপ করুন যাতে আমরা আপনাকে রাইড অপশন দেখাতে পারি",
            "Please enter data in the previous field first !!": "দয়া করে আগে আগের ফিল্ডে তথ্য দিন !!",
            "City to city": "শহর থেকে শহর",
            "Rental": "ভাড়া",
            "Freight": "পণ্য পরিবহন",
            "Pickup location": "পিকআপ লোকেশন",
            "Dropoff location": "ড্রপ লোকেশন",
            "Stop location": "স্টপ লোকেশন",
            "Search location": "লোকেশন খুঁজুন",
            "Length": "দৈর্ঘ্য",
            "Width": "প্রস্থ",
            "Height": "উচ্চতা",
            "For example: a small box, about 1kg": "উদাহরণ: একটি ছোট বক্স, প্রায় ১ কেজি",
            "max_weight": "সর্বোচ্চ {{kg}} কেজি",
            "total_kg_placeholder": "মোট কেজি (সর্বোচ্চ {{kg}} কেজি)",
            "Select Ride Type": "রাইডের ধরন নির্বাচন করুন",
            "Select Outstation Services": "আউটস্টেশন সার্ভিস নির্বাচন করুন",
            "Available Vehicle Types": "উপলব্ধ যানবাহনের ধরন",
            "Select Date & Time": "তারিখ ও সময় নির্বাচন করুন",
            "Number of passengers": "যাত্রীর সংখ্যা",
            "Rental Type": "ভাড়ার ধরন",
            "How much time do you need?": "আপনার কত সময় প্রয়োজন?",
            "hours": "ঘণ্টা",
            "Sender & Recevier info": "প্রেরক ও গ্রহণকারীর তথ্য",
            "Vehicle size": "যানবাহনের আকার",
            "Please select pickup location !!": "দয়া করে পিকআপ লোকেশন নির্বাচন করুন !!",
            "Please select dropoff location !!": "দয়া করে ড্রপ লোকেশন নির্বাচন করুন !!",
            "Please select all details !!": "দয়া করে সব তথ্য নির্বাচন করুন !!",
            "Please fill all stop locations !!": "দয়া করে সব স্টপ লোকেশন পূরণ করুন !!",
            "Select date": "তারিখ নির্বাচন করুন",
            "Select time": "সময় নির্বাচন করুন",
            "Find a driver": "একজন ড্রাইভার খুঁজুন",
            "Choose a ride": "একটি রাইড নির্বাচন করুন",
            "Please fill sender & recevier info !!": "দয়া করে প্রেরক ও গ্রহণকারীর তথ্য পূরণ করুন !!",
            "Please fill Package details !!": "দয়া করে প্যাকেজের বিবরণ পূরণ করুন !!",
            "Create request": "অনুরোধ তৈরি করুন",
            "Sender Phone Number": "প্রেরকের ফোন নম্বর",
            "Recevier Phone Number": "গ্রহণকারীর ফোন নম্বর",
            "Enter details": "বিস্তারিত লিখুন",
            "max_passenger": "সর্বোচ্চ যাত্রী সংখ্যা {{count}}",
            "max_hours": "সর্বোচ্চ ঘণ্টা {{count}}",
            "Please write a message !!": "দয়া করে একটি বার্তা লিখুন !!",
            "Start Conversation...": "কথোপকথন শুরু করুন...",
            "Faq Question & Answer": "প্রশ্নোত্তর",
            "Please select service !!": "দয়া করে একটি সার্ভিস নির্বাচন করুন !!",
            "Get a ride": "রাইড নিন",
            "Select service": "সার্ভিস নির্বাচন করুন",
            "min away - Drop": "মিনিট দূরে - ড্রপ",
            "Your ride,": "আপনার রাইড,",
            "your way": "আপনার মতো",
            "Experience the next generation of urban mobility. Fast, reliable, and tailored": "নগর চলাচলের নতুন প্রজন্মের অভিজ্ঞতা নিন। দ্রুত, নির্ভরযোগ্য এবং উপযোগী",
            "to your daily needs.": "আপনার দৈনন্দিন প্রয়োজন অনুযায়ী।",
            "Pickup Location": "পিকআপ লোকেশন",
            "Drop-off Location": "ড্রপ-অফ লোকেশন",
            "Find Ride": "রাইড খুঁজুন",
            "Our Services": "আমাদের সেবা",
            "Book now": "এখনই বুক করুন",
            "Real-Time Tracking": "রিয়েল-টাইম ট্র্যাকিং",
            "Set Your Pickup": "আপনার পিকআপ সেট করুন",
            "Enter your pickup and drop location. Our system instantly finds the nearest driver to you.": "আপনার পিকআপ ও ড্রপ লোকেশন দিন। আমাদের সিস্টেম দ্রুত নিকটতম ড্রাইভার খুঁজে দেয়।",
            "Driver Matched": "ড্রাইভার মেলানো হয়েছে",
            "A verified, top-rated driver is matched to your ride within 30 seconds of booking.": "বুকিংয়ের ৩০ সেকেন্ডের মধ্যে একটি যাচাইকৃত ড্রাইভার আপনার রাইডে যুক্ত হয়।",
            "Track in Real-Time": "রিয়েল-টাইমে ট্র্যাক করুন",
            "Watch your driver's live location on the map. Share ETA with friends or family.": "ম্যাপে আপনার ড্রাইভারের লাইভ লোকেশন দেখুন। বন্ধু বা পরিবারের সাথে ETA শেয়ার করুন।",
            "Arrive & Pay": "পৌঁছান ও পরিশোধ করুন",
            "Pay via UPI, card, or cash. Rate your driver and get a digital receipt instantly.": "UPI, কার্ড বা নগদে পরিশোধ করুন। ড্রাইভারকে রেট করুন এবং সাথে সাথে ডিজিটাল রসিদ পান।",
            "Location permission not enabled": "লোকেশন পারমিশন চালু নেই",
            "Sharing Location permission helps us improve your ride booking and pickup experience.": "লোকেশন পারমিশন চালু করলে আপনার রাইড বুকিং ও পিকআপ অভিজ্ঞতা উন্নত হয়।",
            "Allow Permission": "পারমিশন দিন",
            "Allow Notification and on-ride alerts": "নোটিফিকেশন ও রাইড অ্যালার্ট অনুমতি দিন",
            "Real-time Captain updates": "রিয়েল-টাইম ড্রাইভার আপডেট",
            "Get notified about captain's allocation,": "ড্রাইভার অ্যাসাইনমেন্ট সম্পর্কে নোটিফিকেশন পান,",
            "arrival and more": "আগমন এবং আরও",
            "Offer and news": "অফার ও খবর",
            "Be the first to konw about our offers": "আমাদের অফার সম্পর্কে প্রথম জানুন",
            "and new features": "এবং নতুন ফিচার",
            "Allow": "অনুমতি দিন",
            "Maybe, later": "হয়তো পরে",
            "Continue Booking": "বুকিং চালিয়ে যান",
            "Please select pickup and drop location !!": "দয়া করে পিকআপ ও ড্রপ লোকেশন নির্বাচন করুন !!",
            "Where from?": "কোথা থেকে?",
            "Where to?": "কোথায় যাবেন?",
            "Fast Pickup": "দ্রুত পিকআপ",
            "Average wait time under 5 minutes in all major cities.": "সব বড় শহরে গড় অপেক্ষার সময় ৫ মিনিটের কম।",
            "Safe Rides": "নিরাপদ রাইড",
            "Background checked drivers and SOS features for safety.": "নিরাপত্তার জন্য যাচাইকৃত ড্রাইভার এবং SOS সুবিধা রয়েছে।",
            "24/7 Support": "২৪/৭ সহায়তা",
            "Our dedicated team is always here to help you anywhere.": "আমাদের নিবেদিত দল সবসময় যেকোনো জায়গায় আপনাকে সাহায্য করতে প্রস্তুত।",
            "Best Prices": "সেরা মূল্য",
            "Optimized routes and fair pricing compared to others.": "অন্যান্যদের তুলনায় অপ্টিমাইজড রুট এবং ন্যায্য মূল্য।",
            "Payment was faild! please try agine": "পেমেন্ট ব্যর্থ হয়েছে! দয়া করে আবার চেষ্টা করুন",
            "Rides History": "রাইড ইতিহাস",
            "View your completed rides and upcoming bookings.": "আপনার সম্পন্ন রাইড এবং আসন্ন বুকিং দেখুন।",
            "Upcoming": "আসন্ন",
            "Completed": "সম্পন্ন",
            "Cancelled": "বাতিল",
            "Date": "তারিখ",
            "Time": "সময়",
            "Estimated Fare": "আনুমানিক ভাড়া",
            "PICKUP": "পিকআপ",
            "DESTINATION": "গন্তব্য",
            "View Details": "বিস্তারিত দেখুন",
            "No Order Found!": "কোনো অর্ডার পাওয়া যায়নি!",
            "Currently you don't have order.": "বর্তমানে আপনার কোনো অর্ডার নেই।",
            "Review & Rating": "রিভিউ ও রেটিং",
            "How was your ride with": "আপনার রাইড কেমন ছিল",
            "Great, what did you like the mast? 😍": "দারুণ! আপনি সবচেয়ে কী পছন্দ করেছেন? 😍",
            "Submit": "জমা দিন",
            "Skip": "এড়িয়ে যান",
            "Driver Profile": "ড্রাইভার প্রোফাইল",
            "Rating": "রেটিং",
            "Trips": "ট্রিপ",
            "Joined": "যোগদান",
            "Since": "থেকে",
            "Verified": "যাচাইকৃত",
            "Reviews": "পর্যালোচনা",
            "Languages": "ভাষা",
            "Preference": "পছন্দ",
            "Phone Number": "ফোন নম্বর",
            "Referral code copied!": "রেফারেল কোড কপি হয়েছে!",
            "Refer & Earn": "রেফার করে আয় করুন",
            "Share and earn rewards together!": "শেয়ার করুন এবং একসাথে পুরস্কার অর্জন করুন!",
            "Your Referral Code": "আপনার রেফারেল কোড",
            "Share this code with your friends": "এই কোডটি আপনার বন্ধুদের সাথে শেয়ার করুন",
            "Copy": "কপি করুন",
            "WhatsApp": "হোয়াটসঅ্যাপ",
            "SMS": "এসএমএস",
            "More": "আরও",
            "Share via your favorite social platform": "আপনার পছন্দের সোশ্যাল প্ল্যাটফর্মে শেয়ার করুন",
            "How It Works": "কিভাবে কাজ করে",
            "Share Your Code": "আপনার কোড শেয়ার করুন",
            "Share your unique referral code with friends and family": "আপনার ইউনিক রেফারেল কোড বন্ধু ও পরিবারের সাথে শেয়ার করুন",
            "Friend Signs Up": "বন্ধু সাইন আপ করে",
            "You Earn Rewards": "আপনি পুরস্কার অর্জন করেন",
            "Everyone Wins!": "সবাই লাভবান!",
            "Both you and your friend can use the credits for consultations, medicines, and lab tests": "আপনি এবং আপনার বন্ধু উভয়েই এই ক্রেডিট ব্যবহার করতে পারবেন পরামর্শ, ওষুধ এবং ল্যাব টেস্টের জন্য",
            "My Wallet": "আমার ওয়ালেট",
            "Total Balance": "মোট ব্যালেন্স",
            "Add Money": "টাকা যোগ করুন",
            "Transaction History": "লেনদেনের ইতিহাস",
            "No transactions yet": "এখনো কোনো লেনদেন নেই",
            "Your transaction history will appear here": "আপনার লেনদেনের ইতিহাস এখানে প্রদর্শিত হবে",
            "Build better products with flexible tools, helpful documentation": "নমনীয় টুল এবং সহায়ক ডকুমেন্টেশনের মাধ্যমে উন্নত পণ্য তৈরি করুন",
            "and a team that champions your growth.": "এবং একটি দল যা আপনার উন্নয়নকে সমর্থন করে।",
            "Useful Link": "উপকারী লিংক",
            "Socials": "সোশ্যাল",
            "* Terms and conditions apply. Rewards will be credited after successful signup.": "* শর্তাবলী প্রযোজ্য। সফল সাইন আপের পর পুরস্কার প্রদান করা হবে।",
            "Enter Full Name": "পূর্ণ নাম লিখুন",
            "Enter Email Address": "ইমেইল ঠিকানা লিখুন",
            "Enter Password": "পাসওয়ার্ড লিখুন",
            "Enter Phone Number": "ফোন নম্বর লিখুন",
            "Credit": "ক্রেডিট",
            "Debit": "ডেবিট",
            "Update": "আপডেট",
            "Please enter amount !!": "দয়া করে পরিমাণ লিখুন !!",
            "Please select payment method": "দয়া করে পেমেন্ট পদ্ধতি নির্বাচন করুন",
            "Select Paymet Method": "পেমেন্ট পদ্ধতি নির্বাচন করুন",
            "Add Wallet Amount": "ওয়ালেটে টাকা যোগ করুন",
            "Enter amount": "পরিমাণ লিখুন",
            "refer_credit": "প্রতিটি সফল রেফারেলের জন্য আপনি আপনার ওয়ালেটে ₹{{refer_credit}} পাবেন",
            "signup_credit": "আপনার বন্ধু আপনার রেফারেল কোড ব্যবহার করে নিবন্ধন করলে সঙ্গে সঙ্গে ₹{{signup_credit}} পাবে",
            "footer_title": "© {{getFullYear}} ZippyGo. সর্বস্বত্ব সংরক্ষিত।",
            "Driver Offer": "ড্রাইভারের অফার",
            "km": "কিমি",
            "min": "মিনিট",
            "Decline": "প্রত্যাখ্যান করুন",
            "Accept": "গ্রহণ করুন",
            "Install Progressive Web Application": "প্রোগ্রেসিভ ওয়েব অ্যাপ্লিকেশন ইনস্টল করুন",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "এই সাইটে অ্যাপের ফিচার রয়েছে। বিস্তৃত অভিজ্ঞতা এবং সহজে অ্যাক্সেসের জন্য এটিকে আপনার ডিভাইসে ইনস্টল করুন।",
            "Install": "ইনস্টল করুন"
        }
    },
    in: {
        translation: {
            "My ride": "Perjalanan saya",
            "Wallet": "Dompet",
            "Language": "Bahasa",
            "Refer and earn": "Ajak teman & dapatkan",
            "Faq": "FAQ",
            "Notification": "Notifikasi",
            "Logout Successfully !!": "Berhasil keluar !!",
            "Login": "Masuk",
            "Select Language": "Pilih bahasa",
            "Please enter phone number !!": "Silakan masukkan nomor telepon !!",
            "In Valid OTP !!": "OTP tidak valid !!",
            "Please enter passwords !!": "Silakan masukkan kata sandi !!",
            "Password not match !!": "Kata sandi tidak cocok !!",
            "Forgot Password": "Lupa kata sandi",
            "Enter OTP code": "Masukkan kode OTP",
            "Enter New Pasword": "Masukkan kata sandi baru",
            "Select which contact details should we use to reset your password": "Pilih detail kontak yang akan kami gunakan untuk mengatur ulang kata sandi Anda",
            "OTP hase been sent to your mobile number": "OTP telah dikirim ke nomor ponsel Anda",
            "Please enter your new password": "Silakan masukkan kata sandi baru Anda",
            "Phone number": "Nomor telepon",
            "Enter phone number": "Masukkan nomor telepon",
            "Search": "Cari",
            "Password": "Kata sandi",
            "Enter password": "Masukkan kata sandi",
            "Confirm Password": "Konfirmasi kata sandi",
            "Enter confirm password": "Masukkan konfirmasi kata sandi",
            "Continue": "Lanjutkan",
            "Verify OTP": "Verifikasi OTP",
            "Confirm": "Konfirmasi",
            "Back": "Kembali",
            "Please enter password !!": "Silakan masukkan kata sandi !!",
            "Forgot Password?": "Lupa kata sandi?",
            "By clicking continue. You agree to our": "Dengan mengklik lanjutkan, Anda menyetujui",
            "Terms & Conditions": "Syarat & Ketentuan",
            "Register Your Account": "Daftarkan akun Anda",
            "Enter your information below.": "Masukkan informasi Anda di bawah ini.",
            "Full Name": "Nama lengkap",
            "Email Address": "Alamat email",
            "Referral Code": "Kode referal",
            "Enter OTP Code": "Masukkan kode OTP",
            "Welcome To Your ZippyGo Ride!": "Selamat datang di perjalanan ZippyGo Anda!",
            "Book a ride in just a few taps and reach your destination comfortably.": "Pesan perjalanan hanya dengan beberapa ketukan dan sampai ke tujuan dengan nyaman.",
            "Please fill all details !!": "Silakan isi semua detail !!",
            "Enter full name": "Masukkan nama lengkap",
            "Enter email address": "Masukkan alamat email",
            "Enter referral code(optional)": "Masukkan kode referal (opsional)",
            "Let's Go": "Ayo mulai",
            "Why do you want to cancel ?": "Mengapa Anda ingin membatalkan?",
            "Please provide the reason for cancellation.": "Silakan berikan alasan pembatalan.",
            "Are you sure you want to cancel thi ride?": "Apakah Anda yakin ingin membatalkan perjalanan ini?",
            "We have found captains near you, please wait for a whilw, your ride should be.": "Kami telah menemukan pengemudi di dekat Anda, harap tunggu sebentar.",
            "Yes, Cancel": "Ya, batalkan",
            "Booking id": "ID pemesanan",
            "Ride Details": "Detail perjalanan",
            "Ride Type": "Jenis perjalanan",
            "Car Type": "Jenis mobil",
            "Hours & Minites": "Jam & menit",
            "Hours": "Jam",
            "Minites": "Menit",
            "Date & Time": "Tanggal & waktu",
            "Payment Details": "Detail pembayaran",
            "Platform Fee": "Biaya platform",
            "Km Charge": "Biaya per km",
            "Additional Time Charge": "Biaya waktu tambahan",
            "Minutes": "Menit",
            "Bid amount": "Jumlah tawaran",
            "Extra Charge": "Biaya tambahan",
            "Total": "Total",
            "Invoice": "Faktur",
            "Rate your ride": "Nilai perjalanan Anda",
            "Minimum fare is": "Tarif minimum adalah",
            "Maximum fare is": "Tarif maksimum adalah",
            "Finding a ride": "Mencari perjalanan",
            "for you": "untuk Anda",
            "ride": "perjalanan",
            "💡 Raise the fare. increase your chance.": "💡 Naikkan tarif untuk meningkatkan peluang Anda.",
            "Automatically book the nearest": "Pesan otomatis yang terdekat",
            "driver for": "pengemudi untuk",
            "Book for": "Pesan untuk",
            "Cancel request": "Batalkan permintaan",
            "Pickup": "Jemput",
            "Drop": "Antar",
            "Time's up. Extra charges apply": "Waktu habis. Biaya tambahan berlaku",
            "Start your order with PIN": "Mulai pesanan dengan PIN",
            "Total Fare": "Total tarif",
            "Paying Via": "Bayar melalui",
            "Cancel Ride": "Batalkan perjalanan",
            "Additional time": "Waktu tambahan",
            "minit": "menit",
            "Base Fare": "Tarif dasar",
            "Select Payment Method": "Pilih metode pembayaran",
            "Set your price": "Atur harga Anda",
            "Cash": "Tunai",
            "Coupon": "Kupon",
            "Captain on the way": "Pengemudi sedang menuju",
            "Captain has arrived": "Pengemudi telah tiba",
            "Heading to the destination": "Menuju ke tujuan",
            "+ Add stop": "+ Tambah pemberhentian",
            "Choose your pickup spot": "Pilih lokasi penjemputan Anda",
            "Confirm pickup": "Konfirmasi penjemputan",
            "Cancel": "Batal",
            "Location search": "Cari lokasi",
            "Set location on map": "Atur lokasi di peta",
            "Recommended fare": "Tarif yang direkomendasikan",
            "Total Km": "Total km",
            "Total Hours": "Total jam",
            "Total Minutes": "Total menit",
            "Weather Charge": "Biaya cuaca",
            "Extra Person Charge": "Biaya orang tambahan",
            "Day Charge": "Biaya harian",
            "Per Hours Charge x 1": "Biaya per jam x 1",
            "Per Hours Discount": "Diskon per jam",
            "Kg Charge": "Biaya per kg",
            "Tax": "Pajak",
            "Total Price": "Total harga",
            "Find Driver": "Cari pengemudi",
            "Select Coupon": "Pilih kupon",
            "Coupon Code": "Kode kupon",
            "Coupon Amount": "Jumlah kupon",
            "Minimum Amount": "Jumlah minimum",
            "Ex Date": "Tanggal kedaluwarsa",
            "Apply Coupon": "Gunakan kupon",
            "Remove Coupon": "Hapus kupon",
            "Captains are busy": "Pengemudi sedang sibuk",
            "Try Again": "Coba lagi",
            "Package details": "Detail paket",
            "Save": "Simpan",
            "Log in to see ride options": "Masuk untuk melihat opsi perjalanan",
            "Please take a moment to quickly log in or sign up so we can show you your ride options": "Silakan masuk atau daftar dengan cepat agar kami dapat menampilkan opsi perjalanan Anda",
            "Please enter data in the previous field first !!": "Silakan isi data pada kolom sebelumnya terlebih dahulu !!",
            "City to city": "Antar kota",
            "Rental": "Sewa",
            "Freight": "Pengiriman barang",
            "Pickup location": "Lokasi penjemputan",
            "Dropoff location": "Lokasi tujuan",
            "Stop location": "Lokasi pemberhentian",
            "Search location": "Cari lokasi",
            "Length": "Panjang",
            "Width": "Lebar",
            "Height": "Tinggi",
            "For example: a small box, about 1kg": "Contoh: kotak kecil, sekitar 1kg",
            "max_weight": "Maksimum {{kg}} kg",
            "total_kg_placeholder": "Total kg (Maksimum {{kg}} kg)",
            "Select Ride Type": "Pilih jenis perjalanan",
            "Select Outstation Services": "Pilih layanan luar kota",
            "Available Vehicle Types": "Jenis kendaraan yang tersedia",
            "Select Date & Time": "Pilih tanggal & waktu",
            "Number of passengers": "Jumlah penumpang",
            "Rental Type": "Jenis sewa",
            "How much time do you need?": "Berapa lama waktu yang Anda butuhkan?",
            "hours": "jam",
            "Sender & Recevier info": "Informasi pengirim & penerima",
            "Vehicle size": "Ukuran kendaraan",
            "Please select pickup location !!": "Silakan pilih lokasi penjemputan !!",
            "Please select dropoff location !!": "Silakan pilih lokasi tujuan !!",
            "Please select all details !!": "Silakan pilih semua detail !!",
            "Please fill all stop locations !!": "Silakan isi semua lokasi pemberhentian !!",
            "Select date": "Pilih tanggal",
            "Select time": "Pilih waktu",
            "Find a driver": "Cari pengemudi",
            "Choose a ride": "Pilih perjalanan",
            "Please fill sender & recevier info !!": "Silakan isi informasi pengirim & penerima !!",
            "Please fill Package details !!": "Silakan isi detail paket !!",
            "Create request": "Buat permintaan",
            "Sender Phone Number": "Nomor telepon pengirim",
            "Recevier Phone Number": "Nomor telepon penerima",
            "Enter details": "Masukkan detail",
            "max_passenger": "Kapasitas maksimum penumpang {{count}}",
            "max_hours": "Maksimum jam {{count}}",
            "Please write a message !!": "Silakan tulis pesan !!",
            "Start Conversation...": "Mulai percakapan...",
            "Faq Question & Answer": "FAQ Pertanyaan & Jawaban",
            "Please select service !!": "Silakan pilih layanan !!",
            "Get a ride": "Dapatkan perjalanan",
            "Select service": "Pilih layanan",
            "min away - Drop": "menit lagi - Tujuan",
            "Your ride,": "Perjalanan Anda,",
            "your way": "cara Anda",
            "Experience the next generation of urban mobility. Fast, reliable, and tailored": "Rasakan generasi baru mobilitas perkotaan. Cepat, andal, dan disesuaikan",
            "to your daily needs.": "dengan kebutuhan harian Anda.",
            "Pickup Location": "Lokasi penjemputan",
            "Drop-off Location": "Lokasi tujuan",
            "Find Ride": "Cari perjalanan",
            "Our Services": "Layanan kami",
            "Book now": "Pesan sekarang",
            "Real-Time Tracking": "Pelacakan waktu nyata",
            "Set Your Pickup": "Atur penjemputan Anda",
            "Enter your pickup and drop location. Our system instantly finds the nearest driver to you.": "Masukkan lokasi penjemputan dan tujuan Anda. Sistem kami akan langsung menemukan pengemudi terdekat.",
            "Driver Matched": "Pengemudi ditemukan",
            "A verified, top-rated driver is matched to your ride within 30 seconds of booking.": "Pengemudi terverifikasi dengan rating tinggi akan ditugaskan dalam 30 detik setelah pemesanan.",
            "Track in Real-Time": "Lacak secara real-time",
            "Watch your driver's live location on the map. Share ETA with friends or family.": "Lihat lokasi pengemudi secara langsung di peta. Bagikan ETA dengan teman atau keluarga.",
            "Arrive & Pay": "Tiba & bayar",
            "Pay via UPI, card, or cash. Rate your driver and get a digital receipt instantly.": "Bayar melalui UPI, kartu, atau tunai. Beri rating pengemudi dan dapatkan struk digital.",
            "Location permission not enabled": "Izin lokasi belum diaktifkan",
            "Sharing Location permission helps us improve your ride booking and pickup experience.": "Mengaktifkan izin lokasi membantu meningkatkan pengalaman pemesanan dan penjemputan Anda.",
            "Allow Permission": "Izinkan akses",
            "Allow Notification and on-ride alerts": "Izinkan notifikasi dan peringatan perjalanan",
            "Real-time Captain updates": "Pembaruan pengemudi real-time",
            "Get notified about captain's allocation,": "Dapatkan notifikasi tentang penugasan pengemudi,",
            "arrival and more": "kedatangan, dan lainnya",
            "Offer and news": "Penawaran dan berita",
            "Be the first to konw about our offers": "Jadilah yang pertama mengetahui penawaran kami",
            "and new features": "dan fitur baru",
            "Allow": "Izinkan",
            "Maybe, later": "Mungkin nanti",
            "Continue Booking": "Lanjutkan pemesanan",
            "Please select pickup and drop location !!": "Silakan pilih lokasi penjemputan dan tujuan !!",
            "Where from?": "Dari mana?",
            "Where to?": "Ke mana?",
            "Fast Pickup": "Penjemputan cepat",
            "Average wait time under 5 minutes in all major cities.": "Waktu tunggu rata-rata kurang dari 5 menit di kota besar.",
            "Safe Rides": "Perjalanan aman",
            "Background checked drivers and SOS features for safety.": "Pengemudi telah melalui pemeriksaan latar belakang dan dilengkapi fitur SOS untuk keamanan.",
            "24/7 Support": "Dukungan 24/7",
            "Our dedicated team is always here to help you anywhere.": "Tim kami yang berdedikasi selalu siap membantu Anda di mana saja.",
            "Best Prices": "Harga terbaik",
            "Optimized routes and fair pricing compared to others.": "Rute yang dioptimalkan dan harga yang adil dibandingkan yang lain.",
            "Payment was faild! please try agine": "Pembayaran gagal! silakan coba lagi",
            "Rides History": "Riwayat perjalanan",
            "View your completed rides and upcoming bookings.": "Lihat perjalanan yang telah selesai dan pemesanan yang akan datang.",
            "Upcoming": "Akan datang",
            "Completed": "Selesai",
            "Cancelled": "Dibatalkan",
            "Date": "Tanggal",
            "Time": "Waktu",
            "Estimated Fare": "Perkiraan tarif",
            "PICKUP": "PENJEMPUTAN",
            "DESTINATION": "TUJUAN",
            "View Details": "Lihat detail",
            "No Order Found!": "Tidak ada pesanan ditemukan!",
            "Currently you don't have order.": "Saat ini Anda tidak memiliki pesanan.",
            "Review & Rating": "Ulasan & penilaian",
            "How was your ride with": "Bagaimana perjalanan Anda dengan",
            "Great, what did you like the mast? 😍": "Bagus! Apa yang paling Anda sukai? 😍",
            "Submit": "Kirim",
            "Skip": "Lewati",
            "Driver Profile": "Profil pengemudi",
            "Rating": "Penilaian",
            "Trips": "Perjalanan",
            "Joined": "Bergabung",
            "Since": "Sejak",
            "Verified": "Terverifikasi",
            "Reviews": "Ulasan",
            "Languages": "Bahasa",
            "Preference": "Preferensi",
            "Phone Number": "Nomor telepon",
            "Referral code copied!": "Kode referal disalin!",
            "Refer & Earn": "Ajak & dapatkan",
            "Share and earn rewards together!": "Bagikan dan dapatkan hadiah bersama!",
            "Your Referral Code": "Kode referal Anda",
            "Share this code with your friends": "Bagikan kode ini kepada teman Anda",
            "Copy": "Salin",
            "WhatsApp": "WhatsApp",
            "SMS": "SMS",
            "More": "Lainnya",
            "Share via your favorite social platform": "Bagikan melalui platform sosial favorit Anda",
            "How It Works": "Cara kerja",
            "Share Your Code": "Bagikan kode Anda",
            "Share your unique referral code with friends and family": "Bagikan kode referal unik Anda kepada teman dan keluarga",
            "Friend Signs Up": "Teman mendaftar",
            "You Earn Rewards": "Anda mendapatkan hadiah",
            "Everyone Wins!": "Semua menang!",
            "Both you and your friend can use the credits for consultations, medicines, and lab tests": "Anda dan teman Anda dapat menggunakan kredit untuk konsultasi, obat, dan tes laboratorium",
            "My Wallet": "Dompet saya",
            "Total Balance": "Total saldo",
            "Add Money": "Tambah uang",
            "Transaction History": "Riwayat transaksi",
            "No transactions yet": "Belum ada transaksi",
            "Your transaction history will appear here": "Riwayat transaksi Anda akan muncul di sini",
            "Build better products with flexible tools, helpful documentation": "Bangun produk yang lebih baik dengan alat fleksibel dan dokumentasi yang membantu",
            "and a team that champions your growth.": "dan tim yang mendukung perkembangan Anda.",
            "Useful Link": "Tautan berguna",
            "Socials": "Sosial",
            "* Terms and conditions apply. Rewards will be credited after successful signup.": "* Syarat dan ketentuan berlaku. Hadiah akan diberikan setelah pendaftaran berhasil.",
            "Enter Full Name": "Masukkan nama lengkap",
            "Enter Email Address": "Masukkan alamat email",
            "Enter Password": "Masukkan kata sandi",
            "Enter Phone Number": "Masukkan nomor telepon",
            "Credit": "Kredit",
            "Debit": "Debit",
            "Update": "Perbarui",
            "Please enter amount !!": "Silakan masukkan jumlah !!",
            "Please select payment method": "Silakan pilih metode pembayaran",
            "Select Paymet Method": "Pilih metode pembayaran",
            "Add Wallet Amount": "Tambah saldo dompet",
            "Enter amount": "Masukkan jumlah",
            "refer_credit": "Anda akan menerima ₹{{refer_credit}} di dompet Anda untuk setiap referal yang berhasil",
            "signup_credit": "Teman Anda mendaftar menggunakan kode referal Anda dan langsung mendapatkan ₹{{signup_credit}}",
            "footer_title": "© {{getFullYear}} ZippyGo. Hak cipta dilindungi.",
            "Driver Offer": "Penawaran Pengemudi",
            "km": "km",
            "min": "menit",
            "Decline": "Tolak",
            "Accept": "Terima",
            "Install Progressive Web Application": "Pasang Aplikasi Web Progresif",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "Situs ini memiliki fungsionalitas aplikasi. Pasang di perangkat Anda untuk pengalaman yang lebih lengkap dan akses mudah.",
            "Install": "Pasang"
        }
    },
}


const savedLanguage = secureLocalStorage.getItem('I18') || 'en';

i18n.use(initReactI18next).init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    }
});

export default i18n;